(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 32:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HostPlatform: () => (/* binding */ HostPlatform),
/* harmony export */   MsoAppNames: () => (/* binding */ MsoAppNames)
/* harmony export */ });


var HostPlatform = (HostPlatform2 => {
  HostPlatform2["Mock"] = "mock";
  HostPlatform2["Android"] = "android";
  HostPlatform2["IOS"] = "ios";
  HostPlatform2["Windows"] = "windows";
  HostPlatform2["MacOS"] = "macos";
  HostPlatform2["Web"] = "web";
  HostPlatform2["IFrame"] = "iframe";
  return HostPlatform2;
})(HostPlatform || {});
var MsoAppNames = (MsoAppNames2 => {
  MsoAppNames2["Access"] = "Access";
  MsoAppNames2["Excel"] = "Excel";
  MsoAppNames2["OneNote"] = "OneNote";
  MsoAppNames2["PowerPoint"] = "PowerPoint";
  MsoAppNames2["Project"] = "Project";
  MsoAppNames2["Publisher"] = "Publisher";
  MsoAppNames2["Visio"] = "Visio";
  MsoAppNames2["Word"] = "Word";
  return MsoAppNames2;
})(MsoAppNames || {});

/***/ }),

/***/ 119:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CentroUrlDod: () => (/* binding */ CentroUrlDod),
/* harmony export */   CentroUrlGcc: () => (/* binding */ CentroUrlGcc),
/* harmony export */   CentroUrlGccm: () => (/* binding */ CentroUrlGccm),
/* harmony export */   CentroUrlInt: () => (/* binding */ CentroUrlInt),
/* harmony export */   CentroUrlProd: () => (/* binding */ CentroUrlProd),
/* harmony export */   CentroUrlTenantCloudTypeMap: () => (/* binding */ CentroUrlTenantCloudTypeMap),
/* harmony export */   DefaultMajorVersion: () => (/* binding */ DefaultMajorVersion),
/* harmony export */   KustoEndpoint: () => (/* binding */ KustoEndpoint),
/* harmony export */   PerfPrefix: () => (/* binding */ PerfPrefix),
/* harmony export */   guidRegexPattern: () => (/* binding */ guidRegexPattern)
/* harmony export */ });
/* harmony import */ var ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(366);



const CentroUrlProd = "https://admin.microsoft.com";
const CentroUrlGccm = "https://admin.microsoft.com";
const CentroUrlGcc = "https://portal.office365.us";
const CentroUrlDod = "https://portal.apps.mil";
const CentroUrlInt = "https://admin-ignite.microsoft.com";
const CentroUrlTenantCloudTypeMap = {
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.Worldwide]: CentroUrlProd,
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.China]: CentroUrlProd,
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.EUDB]: CentroUrlProd,
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.GccMod]: CentroUrlGccm,
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.UsGov]: CentroUrlGcc,
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.UsGovDod]: CentroUrlDod,
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.UsNat]: CentroUrlDod,
  [ocv_inapp_feedback_types__WEBPACK_IMPORTED_MODULE_0__.TenantCloudType.UsSec]: CentroUrlDod
};
const PerfPrefix = "OcvFeedback";
const DefaultMajorVersion = "v2";
const guidRegexPattern = /^$|^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const KustoEndpoint = "https://admin.microsoft.com/api/instrument/logclient";

/***/ }),

/***/ 139:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var util = __webpack_require__(254);
var has = Object.prototype.hasOwnProperty;
function ArraySet() {
  this._array = [];
  this._set = Object.create(null);
}
ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet();
  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }
  return set;
};
ArraySet.prototype.size = function ArraySet_size() {
  return Object.getOwnPropertyNames(this._set).length;
};
ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = util.toSetString(aStr);
  var isDuplicate = has.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    this._set[sStr] = idx;
  }
};
ArraySet.prototype.has = function ArraySet_has(aStr) {
  var sStr = util.toSetString(aStr);
  return has.call(this._set, sStr);
};
ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
  var sStr = util.toSetString(aStr);
  if (has.call(this._set, sStr)) {
    return this._set[sStr];
  }
  throw new Error('"' + aStr + '" is not in the set.');
};
ArraySet.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error('No element indexed by ' + aIdx);
};
ArraySet.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};
exports.ArraySet = ArraySet;

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict';
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}
})(this, function () {
  'use strict';

  function _isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  }
  function _getter(p) {
    return function () {
      return this[p];
    };
  }
  var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
  var numericProps = ['columnNumber', 'lineNumber'];
  var stringProps = ['fileName', 'functionName', 'source'];
  var arrayProps = ['args'];
  var objectProps = ['evalOrigin'];
  var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
  function StackFrame(obj) {
    if (!obj) return;
    for (var i = 0; i < props.length; i++) {
      if (obj[props[i]] !== undefined) {
        this['set' + _capitalize(props[i])](obj[props[i]]);
      }
    }
  }
  StackFrame.prototype = {
    getArgs: function () {
      return this.args;
    },
    setArgs: function (v) {
      if (Object.prototype.toString.call(v) !== '[object Array]') {
        throw new TypeError('Args must be an Array');
      }
      this.args = v;
    },
    getEvalOrigin: function () {
      return this.evalOrigin;
    },
    setEvalOrigin: function (v) {
      if (v instanceof StackFrame) {
        this.evalOrigin = v;
      } else if (v instanceof Object) {
        this.evalOrigin = new StackFrame(v);
      } else {
        throw new TypeError('Eval Origin must be an Object or StackFrame');
      }
    },
    toString: function () {
      var fileName = this.getFileName() || '';
      var lineNumber = this.getLineNumber() || '';
      var columnNumber = this.getColumnNumber() || '';
      var functionName = this.getFunctionName() || '';
      if (this.getIsEval()) {
        if (fileName) {
          return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
        }
        return '[eval]:' + lineNumber + ':' + columnNumber;
      }
      if (functionName) {
        return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
      }
      return fileName + ':' + lineNumber + ':' + columnNumber;
    }
  };
  StackFrame.fromString = function StackFrame$$fromString(str) {
    var argsStartIndex = str.indexOf('(');
    var argsEndIndex = str.lastIndexOf(')');
    var functionName = str.substring(0, argsStartIndex);
    var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
    var locationString = str.substring(argsEndIndex + 1);
    if (locationString.indexOf('@') === 0) {
      var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
      var fileName = parts[1];
      var lineNumber = parts[2];
      var columnNumber = parts[3];
    }
    return new StackFrame({
      functionName: functionName,
      args: args || undefined,
      fileName: fileName,
      lineNumber: lineNumber || undefined,
      columnNumber: columnNumber || undefined
    });
  };
  for (var i = 0; i < booleanProps.length; i++) {
    StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
    StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function (p) {
      return function (v) {
        this[p] = Boolean(v);
      };
    }(booleanProps[i]);
  }
  for (var j = 0; j < numericProps.length; j++) {
    StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
    StackFrame.prototype['set' + _capitalize(numericProps[j])] = function (p) {
      return function (v) {
        if (!_isNumber(v)) {
          throw new TypeError(p + ' must be a Number');
        }
        this[p] = Number(v);
      };
    }(numericProps[j]);
  }
  for (var k = 0; k < stringProps.length; k++) {
    StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
    StackFrame.prototype['set' + _capitalize(stringProps[k])] = function (p) {
      return function (v) {
        this[p] = String(v);
      };
    }(stringProps[k]);
  }
  return StackFrame;
});

/***/ }),

/***/ 254:
/***/ ((__unused_webpack_module, exports) => {

function getArg(aArgs, aName, aDefaultValue) {
  if (aName in aArgs) {
    return aArgs[aName];
  } else if (arguments.length === 3) {
    return aDefaultValue;
  } else {
    throw new Error('"' + aName + '" is a required argument.');
  }
}
exports.getArg = getArg;
var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;
function urlParse(aUrl) {
  var match = aUrl.match(urlRegexp);
  if (!match) {
    return null;
  }
  return {
    scheme: match[1],
    auth: match[2],
    host: match[3],
    port: match[4],
    path: match[5]
  };
}
exports.urlParse = urlParse;
function urlGenerate(aParsedUrl) {
  var url = '';
  if (aParsedUrl.scheme) {
    url += aParsedUrl.scheme + ':';
  }
  url += '//';
  if (aParsedUrl.auth) {
    url += aParsedUrl.auth + '@';
  }
  if (aParsedUrl.host) {
    url += aParsedUrl.host;
  }
  if (aParsedUrl.port) {
    url += ":" + aParsedUrl.port;
  }
  if (aParsedUrl.path) {
    url += aParsedUrl.path;
  }
  return url;
}
exports.urlGenerate = urlGenerate;
function normalize(aPath) {
  var path = aPath;
  var url = urlParse(aPath);
  if (url) {
    if (!url.path) {
      return aPath;
    }
    path = url.path;
  }
  var isAbsolute = exports.isAbsolute(path);
  var parts = path.split(/\/+/);
  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
    part = parts[i];
    if (part === '.') {
      parts.splice(i, 1);
    } else if (part === '..') {
      up++;
    } else if (up > 0) {
      if (part === '') {
        parts.splice(i + 1, up);
        up = 0;
      } else {
        parts.splice(i, 2);
        up--;
      }
    }
  }
  path = parts.join('/');
  if (path === '') {
    path = isAbsolute ? '/' : '.';
  }
  if (url) {
    url.path = path;
    return urlGenerate(url);
  }
  return path;
}
exports.normalize = normalize;
function join(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  if (aPath === "") {
    aPath = ".";
  }
  var aPathUrl = urlParse(aPath);
  var aRootUrl = urlParse(aRoot);
  if (aRootUrl) {
    aRoot = aRootUrl.path || '/';
  }
  if (aPathUrl && !aPathUrl.scheme) {
    if (aRootUrl) {
      aPathUrl.scheme = aRootUrl.scheme;
    }
    return urlGenerate(aPathUrl);
  }
  if (aPathUrl || aPath.match(dataUrlRegexp)) {
    return aPath;
  }
  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
    aRootUrl.host = aPath;
    return urlGenerate(aRootUrl);
  }
  var joined = aPath.charAt(0) === '/' ? aPath : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
  if (aRootUrl) {
    aRootUrl.path = joined;
    return urlGenerate(aRootUrl);
  }
  return joined;
}
exports.join = join;
exports.isAbsolute = function (aPath) {
  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
};
function relative(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  aRoot = aRoot.replace(/\/$/, '');
  var level = 0;
  while (aPath.indexOf(aRoot + '/') !== 0) {
    var index = aRoot.lastIndexOf("/");
    if (index < 0) {
      return aPath;
    }
    aRoot = aRoot.slice(0, index);
    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
      return aPath;
    }
    ++level;
  }
  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
exports.relative = relative;
var supportsNullProto = function () {
  var obj = Object.create(null);
  return !('__proto__' in obj);
}();
function identity(s) {
  return s;
}
function toSetString(aStr) {
  if (isProtoString(aStr)) {
    return '$' + aStr;
  }
  return aStr;
}
exports.toSetString = supportsNullProto ? identity : toSetString;
function fromSetString(aStr) {
  if (isProtoString(aStr)) {
    return aStr.slice(1);
  }
  return aStr;
}
exports.fromSetString = supportsNullProto ? identity : fromSetString;
function isProtoString(s) {
  if (!s) {
    return false;
  }
  var length = s.length;
  if (length < 9) {
    return false;
  }
  if (s.charCodeAt(length - 1) !== 95 || s.charCodeAt(length - 2) !== 95 || s.charCodeAt(length - 3) !== 111 || s.charCodeAt(length - 4) !== 116 || s.charCodeAt(length - 5) !== 111 || s.charCodeAt(length - 6) !== 114 || s.charCodeAt(length - 7) !== 112 || s.charCodeAt(length - 8) !== 95 || s.charCodeAt(length - 9) !== 95) {
    return false;
  }
  for (var i = length - 10; i >= 0; i--) {
    if (s.charCodeAt(i) !== 36) {
      return false;
    }
  }
  return true;
}
function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
  var cmp = mappingA.source - mappingB.source;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }
  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }
  return mappingA.name - mappingB.name;
}
exports.compareByOriginalPositions = compareByOriginalPositions;
function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }
  cmp = mappingA.source - mappingB.source;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }
  return mappingA.name - mappingB.name;
}
exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
function strcmp(aStr1, aStr2) {
  if (aStr1 === aStr2) {
    return 0;
  }
  if (aStr1 > aStr2) {
    return 1;
  }
  return -1;
}
function compareByGeneratedPositionsInflated(mappingA, mappingB) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }
  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }
  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;

/***/ }),

/***/ 324:
/***/ ((__unused_webpack_module, exports) => {

function swap(ary, x, y) {
  var temp = ary[x];
  ary[x] = ary[y];
  ary[y] = temp;
}
function randomIntInRange(low, high) {
  return Math.round(low + Math.random() * (high - low));
}
function doQuickSort(ary, comparator, p, r) {
  if (p < r) {
    var pivotIndex = randomIntInRange(p, r);
    var i = p - 1;
    swap(ary, pivotIndex, r);
    var pivot = ary[r];
    for (var j = p; j < r; j++) {
      if (comparator(ary[j], pivot) <= 0) {
        i += 1;
        swap(ary, i, j);
      }
    }
    swap(ary, i + 1, j);
    var q = i + 1;
    doQuickSort(ary, comparator, p, q - 1);
    doQuickSort(ary, comparator, q + 1, r);
  }
}
exports.quickSort = function (ary, comparator) {
  doQuickSort(ary, comparator, 0, ary.length - 1);
};

/***/ }),

/***/ 353:
/***/ ((__unused_webpack_module, exports) => {

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
exports.encode = function (number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }
  throw new TypeError("Must be between 0 and 63: " + number);
};
exports.decode = function (charCode) {
  var bigA = 65;
  var bigZ = 90;
  var littleA = 97;
  var littleZ = 122;
  var zero = 48;
  var nine = 57;
  var plus = 43;
  var slash = 47;
  var littleOffset = 26;
  var numberOffset = 52;
  if (bigA <= charCode && charCode <= bigZ) {
    return charCode - bigA;
  }
  if (littleA <= charCode && charCode <= littleZ) {
    return charCode - littleA + littleOffset;
  }
  if (zero <= charCode && charCode <= nine) {
    return charCode - zero + numberOffset;
  }
  if (charCode == plus) {
    return 62;
  }
  if (charCode == slash) {
    return 63;
  }
  return -1;
};

/***/ }),

/***/ 366:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AllowedClientCountryCodes: () => (/* binding */ AllowedClientCountryCodes),
/* harmony export */   ComplianceMapping: () => (/* binding */ ComplianceMapping),
/* harmony export */   EmailConsentRequestType: () => (/* binding */ EmailConsentRequestType),
/* harmony export */   EmailConsentType: () => (/* binding */ EmailConsentType),
/* harmony export */   FeedbackAgeGroup: () => (/* binding */ FeedbackAgeGroup),
/* harmony export */   FeedbackAttachmentOrigin: () => (/* binding */ FeedbackAttachmentOrigin),
/* harmony export */   FeedbackAuthenticationType: () => (/* binding */ FeedbackAuthenticationType),
/* harmony export */   FeedbackEntryPoint: () => (/* binding */ FeedbackEntryPoint),
/* harmony export */   FeedbackHostEventName: () => (/* binding */ FeedbackHostEventName),
/* harmony export */   FeedbackHostPlatformType: () => (/* binding */ FeedbackHostPlatformType),
/* harmony export */   FeedbackIntegrationSource: () => (/* binding */ FeedbackIntegrationSource),
/* harmony export */   FeedbackPolicyValue: () => (/* binding */ FeedbackPolicyValue),
/* harmony export */   FeedbackScreenshotAutoCaptureConfigSetting: () => (/* binding */ FeedbackScreenshotAutoCaptureConfigSetting),
/* harmony export */   FeedbackScreenshotInfoImageFormat: () => (/* binding */ FeedbackScreenshotInfoImageFormat),
/* harmony export */   FeedbackScreenshotInfoImageOrientation: () => (/* binding */ FeedbackScreenshotInfoImageOrientation),
/* harmony export */   FeedbackScreenshotSourceType: () => (/* binding */ FeedbackScreenshotSourceType),
/* harmony export */   FeedbackType: () => (/* binding */ FeedbackType),
/* harmony export */   FeedbackUiType: () => (/* binding */ FeedbackUiType),
/* harmony export */   InAppFeedbackQuestionUiBehaviour: () => (/* binding */ InAppFeedbackQuestionUiBehaviour),
/* harmony export */   InAppFeedbackQuestionUiType: () => (/* binding */ InAppFeedbackQuestionUiType),
/* harmony export */   InAppFeedbackScenarioType: () => (/* binding */ InAppFeedbackScenarioType),
/* harmony export */   InitializationStatus: () => (/* binding */ InitializationStatus),
/* harmony export */   OrganizationKey: () => (/* binding */ OrganizationKey),
/* harmony export */   PrivacyConsentBlockKey: () => (/* binding */ PrivacyConsentBlockKey),
/* harmony export */   ReproductionModeState: () => (/* binding */ ReproductionModeState),
/* harmony export */   TenantCloudType: () => (/* binding */ TenantCloudType),
/* harmony export */   TenantFeedbackScenarioType: () => (/* binding */ TenantFeedbackScenarioType),
/* harmony export */   UserAccessTokenAudience: () => (/* binding */ UserAccessTokenAudience)
/* harmony export */ });
var FeedbackType;
(function (FeedbackType) {
  FeedbackType["Smile"] = "Smile";
  FeedbackType["Frown"] = "Frown";
  FeedbackType["Idea"] = "Idea";
  FeedbackType["Unclassified"] = "Unclassified";
  FeedbackType["Survey"] = "Survey";
  FeedbackType["ThumbsUp"] = "ThumbsUp";
  FeedbackType["ThumbsDown"] = "ThumbsDown";
})(FeedbackType || (FeedbackType = {}));
var FeedbackAgeGroup;
(function (FeedbackAgeGroup) {
  FeedbackAgeGroup["Undefined"] = "Undefined";
  FeedbackAgeGroup["MinorWithoutParentalConsent"] = "MinorWithoutParentalConsent";
  FeedbackAgeGroup["MinorWithParentalConsent"] = "MinorWithParentalConsent";
  FeedbackAgeGroup["NotAdult"] = "NotAdult";
  FeedbackAgeGroup["Adult"] = "Adult";
  FeedbackAgeGroup["MinorNoParentalConsentRequired"] = "MinorNoParentalConsentRequired";
})(FeedbackAgeGroup || (FeedbackAgeGroup = {}));
var FeedbackAuthenticationType;
(function (FeedbackAuthenticationType) {
  FeedbackAuthenticationType["MSA"] = "MSA";
  FeedbackAuthenticationType["AAD"] = "AAD";
  FeedbackAuthenticationType["Unauthenticated"] = "Unauthenticated";
})(FeedbackAuthenticationType || (FeedbackAuthenticationType = {}));
var FeedbackPolicyValue;
(function (FeedbackPolicyValue) {
  FeedbackPolicyValue["Enabled"] = "Enabled";
  FeedbackPolicyValue["Disabled"] = "Disabled";
  FeedbackPolicyValue["NotConfigured"] = "Not Configured";
  FeedbackPolicyValue["NotApplicable"] = "Not Applicable";
})(FeedbackPolicyValue || (FeedbackPolicyValue = {}));
var FeedbackScreenshotInfoImageFormat;
(function (FeedbackScreenshotInfoImageFormat) {
  FeedbackScreenshotInfoImageFormat["JPEG"] = "jpeg";
  FeedbackScreenshotInfoImageFormat["PNG"] = "png";
})(FeedbackScreenshotInfoImageFormat || (FeedbackScreenshotInfoImageFormat = {}));
var FeedbackScreenshotInfoImageOrientation;
(function (FeedbackScreenshotInfoImageOrientation) {
  FeedbackScreenshotInfoImageOrientation["Landscape"] = "Landscape";
  FeedbackScreenshotInfoImageOrientation["Potrait"] = "Potrait";
})(FeedbackScreenshotInfoImageOrientation || (FeedbackScreenshotInfoImageOrientation = {}));
var FeedbackScreenshotSourceType;
(function (FeedbackScreenshotSourceType) {
  FeedbackScreenshotSourceType["AutoCapture"] = "AutoCapture";
  FeedbackScreenshotSourceType["AutoCaptureWithHtml2Canvas"] = "AutoCaptureWithHtml2Canvas";
  FeedbackScreenshotSourceType["ProvidedAtInitialization"] = "ProvidedAtInitialization";
  FeedbackScreenshotSourceType["DynamicallyProvided"] = "DynamicallyProvided";
  FeedbackScreenshotSourceType["DynamicallyProvidedWithNoTimeout"] = "DynamicallyProvidedWithNoTimeout";
})(FeedbackScreenshotSourceType || (FeedbackScreenshotSourceType = {}));
var FeedbackUiType;
(function (FeedbackUiType) {
  FeedbackUiType["SidePane"] = "SidePane";
  FeedbackUiType["Modal"] = "Modal";
  FeedbackUiType["CallOut"] = "CallOut";
  FeedbackUiType["IFrameWithinSidePane"] = "IFrameWithinSidePane";
  FeedbackUiType["IFrameWithinModal"] = "IFrameWithinModal";
  FeedbackUiType["IFrameWithinCallOut"] = "IFrameWithinCallOut";
  FeedbackUiType["NoSurface"] = "NoSurface";
  FeedbackUiType["NoSurfaceWithoutTitle"] = "NoSurfaceWithoutTitle";
})(FeedbackUiType || (FeedbackUiType = {}));
var FeedbackHostPlatformType;
(function (FeedbackHostPlatformType) {
  FeedbackHostPlatformType["Windows"] = "Windows";
  FeedbackHostPlatformType["IOS"] = "iOS";
  FeedbackHostPlatformType["Android"] = "Android";
  FeedbackHostPlatformType["WacTaskPane"] = "WacTaskPane";
  FeedbackHostPlatformType["MacOS"] = "MacOS";
  FeedbackHostPlatformType["Web"] = "Web";
  FeedbackHostPlatformType["IFrame"] = "IFrame";
})(FeedbackHostPlatformType || (FeedbackHostPlatformType = {}));
var FeedbackHostEventName;
(function (FeedbackHostEventName) {
  FeedbackHostEventName["SubmitClicked"] = "InAppFeedback_HostEvent_SubmitClicked";
  FeedbackHostEventName["BackClicked"] = "InAppFeedback_HostEvent_BackClicked";
  FeedbackHostEventName["CancelClicked"] = "InAppFeedback_HostEvent_CancelClicked";
  FeedbackHostEventName["ReproductionModeStateUpdate"] = "InAppFeedback_HostEvent_ReproductionModeStateUpdate";
  FeedbackHostEventName["ScreenshotEditorAnnouncement"] = "InAppFeedback_HostEvent_ScreenshotEditorAnnouncement";
})(FeedbackHostEventName || (FeedbackHostEventName = {}));
var InitializationStatus;
(function (InitializationStatus) {
  InitializationStatus["Success"] = "Success";
  InitializationStatus["Error"] = "Error";
  InitializationStatus["Warning"] = "Warning";
})(InitializationStatus || (InitializationStatus = {}));
var InAppFeedbackQuestionUiType;
(function (InAppFeedbackQuestionUiType) {
  InAppFeedbackQuestionUiType["DropDown"] = "DropDown";
  InAppFeedbackQuestionUiType["MultiSelect"] = "MultiSelect";
  InAppFeedbackQuestionUiType["Rating"] = "Rating";
  InAppFeedbackQuestionUiType["SingleSelect"] = "SingleSelect";
  InAppFeedbackQuestionUiType["SingleSelectHorizontal"] = "SingleSelectHorizontal";
  InAppFeedbackQuestionUiType["Text"] = "Text";
  InAppFeedbackQuestionUiType["TextPills"] = "TextPills";
})(InAppFeedbackQuestionUiType || (InAppFeedbackQuestionUiType = {}));
var InAppFeedbackScenarioType;
(function (InAppFeedbackScenarioType) {
  InAppFeedbackScenarioType["FeatureArea"] = "FeatureArea";
  InAppFeedbackScenarioType["ResponsibleAI"] = "ResponsibleAI";
  InAppFeedbackScenarioType["Experience"] = "Experience";
  InAppFeedbackScenarioType["ProductSatisfaction"] = "ProductSatisfaction";
  InAppFeedbackScenarioType["CrashImpact"] = "CrashImpact";
  InAppFeedbackScenarioType["Custom"] = "Custom";
  InAppFeedbackScenarioType["AICustom"] = "AICustom";
  InAppFeedbackScenarioType["AIThumbsDown"] = "AIThumbsDown";
  InAppFeedbackScenarioType["AIThumbsUp"] = "AIThumbsUp";
  InAppFeedbackScenarioType["AIError"] = "AIError";
  InAppFeedbackScenarioType["AIGeneral"] = "AIGeneral";
  InAppFeedbackScenarioType["PromptSuggestion"] = "PromptSuggestion";
})(InAppFeedbackScenarioType || (InAppFeedbackScenarioType = {}));
var InAppFeedbackQuestionUiBehaviour;
(function (InAppFeedbackQuestionUiBehaviour) {
  InAppFeedbackQuestionUiBehaviour["QuestionNotRequired"] = "QuestionNotRequired";
  InAppFeedbackQuestionUiBehaviour["CommentNotRequired"] = "CommentNotRequired";
  InAppFeedbackQuestionUiBehaviour["CommentRequiredWithLastOption"] = "CommentRequiredWithLastOption";
  InAppFeedbackQuestionUiBehaviour["TextPillsMultiSelect"] = "TextPillsMultiSelect";
})(InAppFeedbackQuestionUiBehaviour || (InAppFeedbackQuestionUiBehaviour = {}));
var FeedbackAttachmentOrigin;
(function (FeedbackAttachmentOrigin) {
  FeedbackAttachmentOrigin["Application"] = "Application";
  FeedbackAttachmentOrigin["User"] = "User";
})(FeedbackAttachmentOrigin || (FeedbackAttachmentOrigin = {}));
var FeedbackEntryPoint;
(function (FeedbackEntryPoint) {
  FeedbackEntryPoint["Header"] = "Header";
  FeedbackEntryPoint["Footer"] = "Footer";
  FeedbackEntryPoint["Backstage"] = "Backstage";
  FeedbackEntryPoint["HelpMenu"] = "Help Menu";
  FeedbackEntryPoint["Canvas"] = "Canvas";
  FeedbackEntryPoint["Chat"] = "Chat";
  FeedbackEntryPoint["VoiceChat"] = "VoiceChat";
  FeedbackEntryPoint["Pane"] = "Pane";
  FeedbackEntryPoint["BizChatLeftRail"] = "BizChatLeftRail";
  FeedbackEntryPoint["BizChatSidePane"] = "BizChatSidePane";
})(FeedbackEntryPoint || (FeedbackEntryPoint = {}));
var FeedbackIntegrationSource;
(function (FeedbackIntegrationSource) {
  FeedbackIntegrationSource["MSO"] = "MSO";
  FeedbackIntegrationSource["SDX"] = "SDX";
  FeedbackIntegrationSource["VivaUX"] = "VivaUX";
  FeedbackIntegrationSource["OneShell"] = "OneShell";
  FeedbackIntegrationSource["Teams"] = "Teams";
  FeedbackIntegrationSource["Outlook"] = "Outlook";
})(FeedbackIntegrationSource || (FeedbackIntegrationSource = {}));
var TenantCloudType;
(function (TenantCloudType) {
  TenantCloudType["Worldwide"] = "Worldwide";
  TenantCloudType["China"] = "China";
  TenantCloudType["EUDB"] = "EUDB";
  TenantCloudType["GccMod"] = "GccMod";
  TenantCloudType["UsGov"] = "UsGov";
  TenantCloudType["UsGovDod"] = "UsGovDod";
  TenantCloudType["UsNat"] = "UsNat";
  TenantCloudType["UsSec"] = "UsSec";
})(TenantCloudType || (TenantCloudType = {}));
var EmailConsentType;
(function (EmailConsentType) {
  EmailConsentType["NotRequested"] = "Not Requested";
  EmailConsentType["None"] = "None";
  EmailConsentType["Implicit"] = "Implicit";
  EmailConsentType["Explicit"] = "Explicit";
})(EmailConsentType || (EmailConsentType = {}));
var EmailConsentRequestType;
(function (EmailConsentRequestType) {
  EmailConsentRequestType["NotRequested"] = "Not Requested";
  EmailConsentRequestType["Implicit"] = "Implicit";
  EmailConsentRequestType["Explicit"] = "Explicit";
})(EmailConsentRequestType || (EmailConsentRequestType = {}));
var UserAccessTokenAudience;
(function (UserAccessTokenAudience) {
  UserAccessTokenAudience["ODS"] = "ODS";
  UserAccessTokenAudience["TenantFeedback"] = "TenantFeedback";
})(UserAccessTokenAudience || (UserAccessTokenAudience = {}));
var FeedbackScreenshotAutoCaptureConfigSetting;
(function (FeedbackScreenshotAutoCaptureConfigSetting) {
  FeedbackScreenshotAutoCaptureConfigSetting["Include"] = "include";
  FeedbackScreenshotAutoCaptureConfigSetting["Exclude"] = "exclude";
})(FeedbackScreenshotAutoCaptureConfigSetting || (FeedbackScreenshotAutoCaptureConfigSetting = {}));
var ReproductionModeState;
(function (ReproductionModeState) {
  ReproductionModeState["Initial"] = "Initial";
  ReproductionModeState["UnknownError"] = "UnknownError";
  ReproductionModeState["StartInProgress"] = "StartInProgress";
  ReproductionModeState["StartSuccess"] = "StartSuccess";
  ReproductionModeState["StartError"] = "StartError";
  ReproductionModeState["StopInProgress"] = "StopInProgress";
  ReproductionModeState["StopSuccess"] = "StopSuccess";
  ReproductionModeState["StopError"] = "StopError";
  ReproductionModeState["CancelInProgress"] = "CancelInProgress";
  ReproductionModeState["CancelSuccess"] = "CancelSuccess";
  ReproductionModeState["CancelError"] = "CancelError";
  ReproductionModeState["RemoveInProgress"] = "RemoveInProgress";
  ReproductionModeState["RemoveSuccess"] = "RemoveSuccess";
  ReproductionModeState["RemoveError"] = "RemoveError";
})(ReproductionModeState || (ReproductionModeState = {}));
var PrivacyConsentBlockKey;
(function (PrivacyConsentBlockKey) {
  PrivacyConsentBlockKey["CAI"] = "CAI";
  PrivacyConsentBlockKey["M365"] = "M365";
  PrivacyConsentBlockKey["WINDOWSSYS"] = "WINDOWSSYS";
  PrivacyConsentBlockKey["WINDOWSNONSYS"] = "WINDOWSNONSYS";
})(PrivacyConsentBlockKey || (PrivacyConsentBlockKey = {}));
var OrganizationKey;
(function (OrganizationKey) {
  OrganizationKey["CAI"] = "CAI";
  OrganizationKey["M365"] = "M365";
  OrganizationKey["WINDOWSSYS"] = "WINDOWSSYS";
  OrganizationKey["WINDOWSNONSYS"] = "WINDOWSNONSYS";
  OrganizationKey["XBOX"] = "XBOX";
})(OrganizationKey || (OrganizationKey = {}));
var TenantFeedbackScenarioType;
(function (TenantFeedbackScenarioType) {
  TenantFeedbackScenarioType["CopilotChatFeedback"] = "CopilotChatFeedback";
  TenantFeedbackScenarioType["CopilotGlobalFeedback"] = "CopilotGlobalFeedback";
  TenantFeedbackScenarioType["CopilotCatchUpFeedback"] = "CopilotCatchUpFeedback";
  TenantFeedbackScenarioType["CopilotAssistantFeedback"] = "CopilotAssistantFeedback";
})(TenantFeedbackScenarioType || (TenantFeedbackScenarioType = {}));
var AllowedClientCountryCodes = ['AA', 'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AN', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'XE', 'XJ', 'XK', 'XS', 'YE', 'YT', 'ZA', 'ZM', 'ZW', 'ZZ'];
var ComplianceMapping = {
  connectedExperiences: {
    settingId: 'office16;L_ConnectedOfficeExperiences',
    enabledValue: '1',
    disabledValue: '2'
  },
  policyAllowFeedback: {
    settingId: 'office16;L_SendFeedback',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyAllowLimitedFeedback: {
    settingId: 'office16;L_LimitedFeedback',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyAllowCopilotFeedback: {
    settingId: 'office16;L_SendCopilotFeedback',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyAllowSurvey: {
    settingId: 'office16;L_SendSurvey',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyAllowScreenshot: {
    settingId: 'office16;L_Screenshot',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyAllowContact: {
    settingId: 'office16;L_EmailCollection',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyAllowContent: {
    settingId: 'office16;L_LogCollection',
    enabledValue: '1',
    disabledValue: '0'
  },
  policySendPublicFeedback: {
    settingId: 'feedback;L_SendPublicFeedback',
    enabledValue: '1',
    disabledValue: '0'
  },
  optionalConnectedExperiences: {
    settingId: 'office16;L_OptionalConnectedExperiences',
    enabledValue: '1',
    disabledValue: '2'
  },
  policyEmailCollectionDefault: {
    settingId: 'office16;L_FeedbackOptionsDefaults;L_FeedbackOptionsDefaultsEmail',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyScreenshotDefault: {
    settingId: 'office16;L_FeedbackOptionsDefaults;L_FeedbackOptionsDefaultsScreenshot',
    enabledValue: '1',
    disabledValue: '0'
  },
  policyContentSamplesDefault: {
    settingId: 'office16;L_FeedbackOptionsDefaults;L_FeedbackOptionsDefaultsContentSamples',
    enabledValue: '1',
    disabledValue: '0'
  }
};

/***/ }),

/***/ 377:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var util = __webpack_require__(254);
function generatedPositionAfter(mappingA, mappingB) {
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
function MappingList() {
  this._array = [];
  this._sorted = true;
  this._last = {
    generatedLine: -1,
    generatedColumn: 0
  };
}
MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
  this._array.forEach(aCallback, aThisArg);
};
MappingList.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};
MappingList.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};
exports.MappingList = MappingList;

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict';
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(539), __webpack_require__(630), __webpack_require__(489)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}
})(this, function StackTrace(ErrorStackParser, StackGenerator, StackTraceGPS) {
  var _options = {
    filter: function (stackframe) {
      return (stackframe.functionName || '').indexOf('StackTrace$$') === -1 && (stackframe.functionName || '').indexOf('ErrorStackParser$$') === -1 && (stackframe.functionName || '').indexOf('StackTraceGPS$$') === -1 && (stackframe.functionName || '').indexOf('StackGenerator$$') === -1;
    },
    sourceCache: {}
  };
  var _generateError = function StackTrace$$GenerateError() {
    try {
      throw new Error();
    } catch (err) {
      return err;
    }
  };
  function _merge(first, second) {
    var target = {};
    [first, second].forEach(function (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          target[prop] = obj[prop];
        }
      }
      return target;
    });
    return target;
  }
  function _isShapedLikeParsableError(err) {
    return err.stack || err['opera#sourceloc'];
  }
  function _filtered(stackframes, filter) {
    if (typeof filter === 'function') {
      return stackframes.filter(filter);
    }
    return stackframes;
  }
  return {
    get: function StackTrace$$get(opts) {
      var err = _generateError();
      return _isShapedLikeParsableError(err) ? this.fromError(err, opts) : this.generateArtificially(opts);
    },
    getSync: function StackTrace$$getSync(opts) {
      opts = _merge(_options, opts);
      var err = _generateError();
      var stack = _isShapedLikeParsableError(err) ? ErrorStackParser.parse(err) : StackGenerator.backtrace(opts);
      return _filtered(stack, opts.filter);
    },
    fromError: function StackTrace$$fromError(error, opts) {
      opts = _merge(_options, opts);
      var gps = new StackTraceGPS(opts);
      return new Promise(function (resolve) {
        var stackframes = _filtered(ErrorStackParser.parse(error), opts.filter);
        resolve(Promise.all(stackframes.map(function (sf) {
          return new Promise(function (resolve) {
            function resolveOriginal() {
              resolve(sf);
            }
            gps.pinpoint(sf).then(resolve, resolveOriginal)['catch'](resolveOriginal);
          });
        })));
      }.bind(this));
    },
    generateArtificially: function StackTrace$$generateArtificially(opts) {
      opts = _merge(_options, opts);
      var stackFrames = StackGenerator.backtrace(opts);
      if (typeof opts.filter === 'function') {
        stackFrames = stackFrames.filter(opts.filter);
      }
      return Promise.resolve(stackFrames);
    },
    instrument: function StackTrace$$instrument(fn, callback, errback, thisArg) {
      if (typeof fn !== 'function') {
        throw new Error('Cannot instrument non-function object');
      } else if (typeof fn.__stacktraceOriginalFn === 'function') {
        return fn;
      }
      var instrumented = function StackTrace$$instrumented() {
        try {
          this.get().then(callback, errback)['catch'](errback);
          return fn.apply(thisArg || this, arguments);
        } catch (e) {
          if (_isShapedLikeParsableError(e)) {
            this.fromError(e).then(callback, errback)['catch'](errback);
          }
          throw e;
        }
      }.bind(this);
      instrumented.__stacktraceOriginalFn = fn;
      return instrumented;
    },
    deinstrument: function StackTrace$$deinstrument(fn) {
      if (typeof fn !== 'function') {
        throw new Error('Cannot de-instrument non-function object');
      } else if (typeof fn.__stacktraceOriginalFn === 'function') {
        return fn.__stacktraceOriginalFn;
      } else {
        return fn;
      }
    },
    report: function StackTrace$$report(stackframes, url, errorMsg, requestOptions) {
      return new Promise(function (resolve, reject) {
        var req = new XMLHttpRequest();
        req.onerror = reject;
        req.onreadystatechange = function onreadystatechange() {
          if (req.readyState === 4) {
            if (req.status >= 200 && req.status < 400) {
              resolve(req.responseText);
            } else {
              reject(new Error('POST to ' + url + ' failed with status: ' + req.status));
            }
          }
        };
        req.open('post', url);
        req.setRequestHeader('Content-Type', 'application/json');
        if (requestOptions && typeof requestOptions.headers === 'object') {
          var headers = requestOptions.headers;
          for (var header in headers) {
            if (headers.hasOwnProperty(header)) {
              req.setRequestHeader(header, headers[header]);
            }
          }
        }
        var reportPayload = {
          stack: stackframes
        };
        if (errorMsg !== undefined && errorMsg !== null) {
          reportPayload.message = errorMsg;
        }
        req.send(JSON.stringify(reportPayload));
      });
    }
  };
});

/***/ }),

/***/ 460:
/***/ ((__unused_webpack_module, exports) => {

exports.GREATEST_LOWER_BOUND = 1;
exports.LEAST_UPPER_BOUND = 2;
function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
  var cmp = aCompare(aNeedle, aHaystack[mid], true);
  if (cmp === 0) {
    return mid;
  } else if (cmp > 0) {
    if (aHigh - mid > 1) {
      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
    }
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return aHigh < aHaystack.length ? aHigh : -1;
    } else {
      return mid;
    }
  } else {
    if (mid - aLow > 1) {
      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
    }
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return mid;
    } else {
      return aLow < 0 ? -1 : aLow;
    }
  }
}
exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
  if (aHaystack.length === 0) {
    return -1;
  }
  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || exports.GREATEST_LOWER_BOUND);
  if (index < 0) {
    return -1;
  }
  while (index - 1 >= 0) {
    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
      break;
    }
    --index;
  }
  return index;
};

/***/ }),

/***/ 469:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InvalidFileSizeError: () => (/* binding */ InvalidFileSizeError),
/* harmony export */   InvalidFileValidationError: () => (/* binding */ InvalidFileValidationError),
/* harmony export */   WrappingError: () => (/* binding */ WrappingError)
/* harmony export */ });


function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function (t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function () { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
let InvalidFileSizeError = function (_Error) {
  function InvalidFileSizeError(message) {
    _classCallCheck(this, InvalidFileSizeError);
    return _callSuper(this, InvalidFileSizeError, [message]);
  }
  _inherits(InvalidFileSizeError, _Error);
  return _createClass(InvalidFileSizeError);
}(_wrapNativeSuper(Error));
let InvalidFileValidationError = function (_Error2) {
  function InvalidFileValidationError(message) {
    _classCallCheck(this, InvalidFileValidationError);
    return _callSuper(this, InvalidFileValidationError, [message]);
  }
  _inherits(InvalidFileValidationError, _Error2);
  return _createClass(InvalidFileValidationError);
}(_wrapNativeSuper(Error));
let WrappingError = function (_Error3) {
  function WrappingError(error, message) {
    var _this;
    _classCallCheck(this, WrappingError);
    const wrappingMessage = message || "New WrappingError";
    const errorMessage = error.message || "Error with no message";
    _this = _callSuper(this, WrappingError, [wrappingMessage + "; caused by: " + errorMessage]);
    _this.stack = _this.stack + "\n" + error.stack;
    return _this;
  }
  _inherits(WrappingError, _Error3);
  return _createClass(WrappingError);
}(_wrapNativeSuper(Error));

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict';
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(708), __webpack_require__(190)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}
})(this, function (SourceMap, StackFrame) {
  'use strict';
  function _xdr(url) {
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      req.open('get', url);
      req.onerror = reject;
      req.onreadystatechange = function onreadystatechange() {
        if (req.readyState === 4) {
          if (req.status >= 200 && req.status < 300 || url.substr(0, 7) === 'file://' && req.responseText) {
            resolve(req.responseText);
          } else {
            reject(new Error('HTTP status: ' + req.status + ' retrieving ' + url));
          }
        }
      };
      req.send();
    });
  }
  function _atob(b64str) {
    if (typeof window !== 'undefined' && window.atob) {
      return window.atob(b64str);
    } else {
      throw new Error('You must supply a polyfill for window.atob in this environment');
    }
  }
  function _parseJson(string) {
    if (typeof JSON !== 'undefined' && JSON.parse) {
      return JSON.parse(string);
    } else {
      throw new Error('You must supply a polyfill for JSON.parse in this environment');
    }
  }
  function _findFunctionName(source, lineNumber) {
    var syntaxes = [/['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/, /function\s+([^('"`]*?)\s*\(([^)]*)\)/, /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/, /\b(?!(?:if|for|switch|while|with|catch)\b)(?:(?:static)\s+)?(\S+)\s*\(.*?\)\s*\{/, /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*\(.*?\)\s*=>/];
    var lines = source.split('\n');
    var code = '';
    var maxLines = Math.min(lineNumber, 20);
    for (var i = 0; i < maxLines; ++i) {
      var line = lines[lineNumber - i - 1];
      var commentPos = line.indexOf('//');
      if (commentPos >= 0) {
        line = line.substr(0, commentPos);
      }
      if (line) {
        code = line + code;
        var len = syntaxes.length;
        for (var index = 0; index < len; index++) {
          var m = syntaxes[index].exec(code);
          if (m && m[1]) {
            return m[1];
          }
        }
      }
    }
    return undefined;
  }
  function _ensureSupportedEnvironment() {
    if (typeof Object.defineProperty !== 'function' || typeof Object.create !== 'function') {
      throw new Error('Unable to consume source maps in older browsers');
    }
  }
  function _ensureStackFrameIsLegit(stackframe) {
    if (typeof stackframe !== 'object') {
      throw new TypeError('Given StackFrame is not an object');
    } else if (typeof stackframe.fileName !== 'string') {
      throw new TypeError('Given file name is not a String');
    } else if (typeof stackframe.lineNumber !== 'number' || stackframe.lineNumber % 1 !== 0 || stackframe.lineNumber < 1) {
      throw new TypeError('Given line number must be a positive integer');
    } else if (typeof stackframe.columnNumber !== 'number' || stackframe.columnNumber % 1 !== 0 || stackframe.columnNumber < 0) {
      throw new TypeError('Given column number must be a non-negative integer');
    }
    return true;
  }
  function _findSourceMappingURL(source) {
    var sourceMappingUrlRegExp = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/mg;
    var lastSourceMappingUrl;
    var matchSourceMappingUrl;
    while (matchSourceMappingUrl = sourceMappingUrlRegExp.exec(source)) {
      lastSourceMappingUrl = matchSourceMappingUrl[1];
    }
    if (lastSourceMappingUrl) {
      return lastSourceMappingUrl;
    } else {
      throw new Error('sourceMappingURL not found');
    }
  }
  function _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache) {
    return new Promise(function (resolve, reject) {
      var loc = sourceMapConsumer.originalPositionFor({
        line: stackframe.lineNumber,
        column: stackframe.columnNumber
      });
      if (loc.source) {
        var mappedSource = sourceMapConsumer.sourceContentFor(loc.source);
        if (mappedSource) {
          sourceCache[loc.source] = mappedSource;
        }
        resolve(new StackFrame({
          functionName: loc.name || stackframe.functionName,
          args: stackframe.args,
          fileName: loc.source,
          lineNumber: loc.line,
          columnNumber: loc.column
        }));
      } else {
        reject(new Error('Could not get original source for given stackframe and source map'));
      }
    });
  }
  return function StackTraceGPS(opts) {
    if (!(this instanceof StackTraceGPS)) {
      return new StackTraceGPS(opts);
    }
    opts = opts || {};
    this.sourceCache = opts.sourceCache || {};
    this.sourceMapConsumerCache = opts.sourceMapConsumerCache || {};
    this.ajax = opts.ajax || _xdr;
    this._atob = opts.atob || _atob;
    this._get = function _get(location) {
      return new Promise(function (resolve, reject) {
        var isDataUrl = location.substr(0, 5) === 'data:';
        if (this.sourceCache[location]) {
          resolve(this.sourceCache[location]);
        } else if (opts.offline && !isDataUrl) {
          reject(new Error('Cannot make network requests in offline mode'));
        } else {
          if (isDataUrl) {
            var supportedEncodingRegexp = /^data:application\/json;([\w=:"-]+;)*base64,/;
            var match = location.match(supportedEncodingRegexp);
            if (match) {
              var sourceMapStart = match[0].length;
              var encodedSource = location.substr(sourceMapStart);
              var source = this._atob(encodedSource);
              this.sourceCache[location] = source;
              resolve(source);
            } else {
              reject(new Error('The encoding of the inline sourcemap is not supported'));
            }
          } else {
            var xhrPromise = this.ajax(location, {
              method: 'get'
            });
            this.sourceCache[location] = xhrPromise;
            xhrPromise.then(resolve, reject);
          }
        }
      }.bind(this));
    };
    this._getSourceMapConsumer = function _getSourceMapConsumer(sourceMappingURL, defaultSourceRoot) {
      return new Promise(function (resolve, reject) {
        if (this.sourceMapConsumerCache[sourceMappingURL]) {
          resolve(this.sourceMapConsumerCache[sourceMappingURL]);
        } else {
          var sourceMapConsumerPromise = new Promise(function (resolve, reject) {
            return this._get(sourceMappingURL).then(function (sourceMapSource) {
              if (typeof sourceMapSource === 'string') {
                sourceMapSource = _parseJson(sourceMapSource.replace(/^\)\]\}'/, ''));
              }
              if (typeof sourceMapSource.sourceRoot === 'undefined') {
                sourceMapSource.sourceRoot = defaultSourceRoot;
              }
              resolve(new SourceMap.SourceMapConsumer(sourceMapSource));
            }, reject);
          }.bind(this));
          this.sourceMapConsumerCache[sourceMappingURL] = sourceMapConsumerPromise;
          resolve(sourceMapConsumerPromise);
        }
      }.bind(this));
    };
    this.pinpoint = function StackTraceGPS$$pinpoint(stackframe) {
      return new Promise(function (resolve, reject) {
        this.getMappedLocation(stackframe).then(function (mappedStackFrame) {
          function resolveMappedStackFrame() {
            resolve(mappedStackFrame);
          }
          this.findFunctionName(mappedStackFrame).then(resolve, resolveMappedStackFrame)['catch'](resolveMappedStackFrame);
        }.bind(this), reject);
      }.bind(this));
    };
    this.findFunctionName = function StackTraceGPS$$findFunctionName(stackframe) {
      return new Promise(function (resolve, reject) {
        _ensureStackFrameIsLegit(stackframe);
        this._get(stackframe.fileName).then(function getSourceCallback(source) {
          var lineNumber = stackframe.lineNumber;
          var columnNumber = stackframe.columnNumber;
          var guessedFunctionName = _findFunctionName(source, lineNumber, columnNumber);
          if (guessedFunctionName) {
            resolve(new StackFrame({
              functionName: guessedFunctionName,
              args: stackframe.args,
              fileName: stackframe.fileName,
              lineNumber: lineNumber,
              columnNumber: columnNumber
            }));
          } else {
            resolve(stackframe);
          }
        }, reject)['catch'](reject);
      }.bind(this));
    };
    this.getMappedLocation = function StackTraceGPS$$getMappedLocation(stackframe) {
      return new Promise(function (resolve, reject) {
        _ensureSupportedEnvironment();
        _ensureStackFrameIsLegit(stackframe);
        var sourceCache = this.sourceCache;
        var fileName = stackframe.fileName;
        this._get(fileName).then(function (source) {
          var sourceMappingURL = _findSourceMappingURL(source);
          var isDataUrl = sourceMappingURL.substr(0, 5) === 'data:';
          var defaultSourceRoot = fileName.substring(0, fileName.lastIndexOf('/') + 1);
          if (sourceMappingURL[0] !== '/' && !isDataUrl && !/^https?:\/\/|^\/\//i.test(sourceMappingURL)) {
            sourceMappingURL = defaultSourceRoot + sourceMappingURL;
          }
          return this._getSourceMapConsumer(sourceMappingURL, defaultSourceRoot).then(function (sourceMapConsumer) {
            return _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache).then(resolve)['catch'](function () {
              resolve(stackframe);
            });
          });
        }.bind(this), reject)['catch'](reject);
      }.bind(this));
    };
  };
});

/***/ }),

/***/ 520:
/***/ (() => {



/***/ }),

/***/ 525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ScreenCapturer: () => (/* reexport */ ScreenCapturer),
  canDisplayFeedback: () => (/* reexport */ canDisplayFeedback),
  canDisplayFeedbackNonCPS: () => (/* reexport */ canDisplayFeedbackNonCPS),
  canSendEmailToOcv: () => (/* reexport */ canSendEmailToOcv),
  getCentroUrl: () => (/* reexport */ getCentroUrl),
  getCloudPolicyServiceTokenAudience: () => (/* reexport */ getCloudPolicyServiceTokenAudience),
  getConfigFromInitOptions: () => (/* reexport */ getConfigFromInitOptions),
  getConfigs: () => (/* reexport */ getConfigs),
  getEmailConsentType: () => (/* reexport */ getEmailConsentType),
  getOcvEmailConsentType: () => (/* reexport */ getOcvEmailConsentType),
  getPolicyFeatureSettings: () => (/* reexport */ getPolicyFeatureSettings),
  getTenantCloudType: () => (/* reexport */ getTenantCloudType),
  isAIScenario: () => (/* reexport */ isAIScenario),
  isAIThumbsScenarioType: () => (/* reexport */ isAIThumbsScenarioType),
  isDisabledByCloudPolicy: () => (/* reexport */ isDisabledByCloudPolicy),
  isExplicitConsentForEmailProvided: () => (/* reexport */ isExplicitConsentForEmailProvided),
  isFeedbackDisabled: () => (/* reexport */ isFeedbackDisabled),
  isFeedbackLiteEnabledByPolicies: () => (/* reexport */ isFeedbackLiteEnabledByPolicies),
  isFileUploadEnabled: () => (/* reexport */ isFileUploadEnabled),
  isHostManagedContextDataEnabled: () => (/* reexport */ isHostManagedContextDataEnabled),
  isHostManagedContextDataEnabledForAiParams: () => (/* reexport */ isHostManagedContextDataEnabledForAiParams),
  isLocalBuild: () => (/* reexport */ isLocalBuild),
  isOptionalConnectedExperiencesEnabled: () => (/* reexport */ isOptionalConnectedExperiencesEnabled),
  isPolicyMissing: () => (/* reexport */ isPolicyMissing),
  isPublicFeedbackEnabled: () => (/* reexport */ isPublicFeedbackEnabled),
  isReproductionModeEnabled: () => (/* reexport */ isReproductionModeEnabled),
  isScenarioEnabled: () => (/* reexport */ isScenarioEnabled),
  isScreenRecordingEnabled: () => (/* reexport */ isScreenRecordingEnabled),
  isScreenshotEnabled: () => (/* reexport */ isScreenshotEnabled),
  isSelectEmailCollectionDefault: () => (/* reexport */ isSelectEmailCollectionDefault),
  isSelectHostManagedContextDataDefault: () => (/* reexport */ isSelectHostManagedContextDataDefault),
  isSelectScreenshotDefault: () => (/* reexport */ isSelectScreenshotDefault),
  isSelectShareContextDataDefault: () => (/* reexport */ isSelectShareContextDataDefault),
  isShareContextDataEnabled: () => (/* reexport */ isShareContextDataEnabled),
  isThumbsFeedbackType: () => (/* reexport */ isThumbsFeedbackType),
  mergeObjects: () => (/* reexport */ mergeObjects),
  noop: () => (/* reexport */ noop),
  promiseWithTimeout: () => (/* reexport */ promiseWithTimeout),
  sendEventSignal: () => (/* reexport */ sendEventSignal),
  unicodeSafeSubstring: () => (/* reexport */ unicodeSafeSubstring)
});

// EXTERNAL MODULE: ../ocv-inapp-feedback-types/dist/esm/types/FeedbackTypes.js
var FeedbackTypes = __webpack_require__(366);
// EXTERNAL MODULE: ./logging/logging.ts + 7 modules
var logging = __webpack_require__(884);
// EXTERNAL MODULE: ./types/LoggingTypes.ts
var LoggingTypes = __webpack_require__(629);
// EXTERNAL MODULE: ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/v4.js + 5 modules
var v4 = __webpack_require__(561);
;// ./functions/internal/Constants.ts


const MAX_CACHE_SIZE = 100;
const CLOUD_POLICIES_CACHE_KEY = "InAppFeedbackCPSCache";
const TENANT_CLOUD_TYPE_CACHE_KEY = "InAppFeedbackTenantCloudTypeCache";
const CLOUD_CONFIG_CACHE_KEY = "InAppFeedbackCloudConfigCache";
const CLOUD_CONFIG_CACHE_TTL_IN_MINUTES = 30;
const GET_GENERAL_OPEN_ID_CONFIGURATION = tenantId => `https://login.microsoftonline.com/${tenantId}/.well-known/openid-configuration`;
const GET_CHINA_OPEN_ID_CONFIGURATION = tenantId => `https://login.partner.microsoftonline.cn/${tenantId}/.well-known/openid-configuration`;
const CloudPolicyServiceGCCBaseUrl = "https://clients.config.gcc.office.net";
const CloudPolicyServiceUsGovBaseUrl = "https://clients.config.high.office365.us";
const CloudPolicyServiceUsGovDodBaseUrl = "https://clients.config.dod.office365.us";
const CloudPolicyServiceWorldWideBaseUrl = "https://clients.config.office.net";
;// ./functions/internal/PersistentCache.ts


function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _a;


let PersistentCache = function (_ref) {
  function PersistentCache(key, maxCacheSize) {
    _classCallCheck(this, PersistentCache);
    this[_a] = "PersistentCache";
    this.version = 1;
    this.cache = {};
    this.localStorageKey = key;
    this.maxCacheSize = maxCacheSize;
    this.conditionallyDeserializeFromLocalStorage();
  }
  return _createClass(PersistentCache, [{
    key: "delete",
    value: function _delete(key) {
      this.conditionallyDeserializeFromLocalStorage();
      if (!this.cache[key]) {
        return false;
      }
      delete this.cache[key];
      this.conditionallySerializeToLocalStorage();
      return true;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.conditionallyDeserializeFromLocalStorage();
      if (this.size >= this.maxCacheSize) {
        delete this.cache[Object.keys(this.cache)[0]];
      }
      this.cache[key] = value;
      this.conditionallySerializeToLocalStorage();
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.conditionallyDeserializeFromLocalStorage();
      this.cache = {};
      this.conditionallySerializeToLocalStorage();
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn, thisArg) {
      this.conditionallyDeserializeFromLocalStorage();
      Object.entries(this.cache).forEach(args => callbackfn(args[1], args[0], this), thisArg);
    }
  }, {
    key: "get",
    value: function get(key) {
      this.conditionallyDeserializeFromLocalStorage();
      return this.cache[key];
    }
  }, {
    key: "has",
    value: function has(key) {
      this.conditionallyDeserializeFromLocalStorage();
      return !!this.cache[key];
    }
  }, {
    key: _ref,
    value: function () {
      this.conditionallyDeserializeFromLocalStorage();
      return Object.entries(this.cache)[Symbol.iterator]();
    }
  }, {
    key: "entries",
    value: function entries() {
      this.conditionallyDeserializeFromLocalStorage();
      return Object.entries(this.cache).values();
    }
  }, {
    key: "keys",
    value: function keys() {
      this.conditionallyDeserializeFromLocalStorage();
      return Object.keys(this.cache).values();
    }
  }, {
    key: "values",
    value: function values() {
      this.conditionallyDeserializeFromLocalStorage();
      return Object.values(this.cache).values();
    }
  }, {
    key: "conditionallySerializeToLocalStorage",
    value: function conditionallySerializeToLocalStorage() {
      this.lastUpdatedDate = Date.now();
      if (!window.localStorage) {
        return;
      }
      const objectToSerialize = {
        version: this.version,
        cache: this.cache,
        lastUpdatedDate: this.lastUpdatedDate,
        maxCacheSize: this.maxCacheSize
      };
      window.localStorage.setItem(this.localStorageKey, JSON.stringify(objectToSerialize));
    }
  }, {
    key: "conditionallyDeserializeFromLocalStorage",
    value: function conditionallyDeserializeFromLocalStorage() {
      if (!window.localStorage) {
        return;
      }
      this.cache = {};
      const localStorageValue = window.localStorage.getItem(this.localStorageKey);
      if (!localStorageValue) {
        return;
      }
      try {
        const storedCache = JSON.parse(localStorageValue);
        if (!storedCache.cache || typeof storedCache.cache !== "object") {
          (0,logging.LogError)(LoggingTypes.LoggingTags.CpsCacheError, "Invalid cache structure in localStorage", new Error(), {});
          return;
        }
        this.version = storedCache.version;
        this.lastUpdatedDate = storedCache.lastUpdatedDate;
        for (const key of Object.keys(storedCache.cache)) {
          this.cache[key] = storedCache.cache[key];
          if (Object.keys(this.cache).length >= this.maxCacheSize) {
            return;
          }
        }
      } catch (error) {
        (0,logging.LogError)(LoggingTypes.LoggingTags.CpsCacheError, "Failed to parse localStorage data", error instanceof Error ? error : new Error(), {});
      }
    }
  }, {
    key: "size",
    get: function () {
      this.conditionallyDeserializeFromLocalStorage();
      return Object.keys(this.cache).length;
    }
  }]);
}((_a = Symbol.toStringTag, Symbol.iterator));
;// ./functions/internal/CloudPoliciesCache.ts




let _cloudPoliciesCache = null;
const cloudPoliciesCache = () => {
  if (_cloudPoliciesCache === null) {
    _cloudPoliciesCache = new PersistentCache(CLOUD_POLICIES_CACHE_KEY, MAX_CACHE_SIZE);
  }
  return _cloudPoliciesCache;
};
;// ./functions/internal/CloudPolicyServiceTransporter.ts


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};






const NO_POLICIES_CHECK_INTERVAL = 1440;
const getBaseCloudPolicyServiceToken = tenantCloudType => {
  switch (tenantCloudType) {
    case FeedbackTypes.TenantCloudType.GccMod:
      return {
        supported: true,
        audience: CloudPolicyServiceGCCBaseUrl
      };
    case FeedbackTypes.TenantCloudType.UsGov:
      return {
        supported: true,
        audience: CloudPolicyServiceUsGovBaseUrl
      };
    case FeedbackTypes.TenantCloudType.UsGovDod:
      return {
        supported: true,
        audience: CloudPolicyServiceUsGovDodBaseUrl
      };
    case FeedbackTypes.TenantCloudType.UsNat:
    case FeedbackTypes.TenantCloudType.UsSec:
    case FeedbackTypes.TenantCloudType.China:
      return {
        supported: false
      };
  }
  return {
    supported: true,
    audience: CloudPolicyServiceWorldWideBaseUrl
  };
};
const getUri = tenantCloudType => {
  const baseUri = getBaseCloudPolicyServiceToken(tenantCloudType).audience;
  return `${baseUri}/user/v1.0/web/policies`;
};
const getPolicyDef = policy => {
  var _a;
  for (const policyDefinition of Object.values(FeedbackTypes.ComplianceMapping)) {
    if (policyDefinition.settingId.toLowerCase() === ((_a = policy.settingId) == null ? void 0 : _a.toLowerCase())) {
      return policyDefinition;
    }
  }
  return null;
};
const parsePolicies = response => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const policies = {};
  for (const policy of (_c = (_b = (_a = response.value) == null ? void 0 : _a[0]) == null ? void 0 : _b.policiesPayload) != null ? _c : []) {
    const policyDefinition = getPolicyDef(policy);
    if (!policyDefinition) {
      continue;
    }
    switch (String(policy.value)) {
      case policyDefinition.enabledValue:
        policies[policyDefinition.settingId] = FeedbackTypes.FeedbackPolicyValue.Enabled;
        break;
      case policyDefinition.disabledValue:
        policies[policyDefinition.settingId] = FeedbackTypes.FeedbackPolicyValue.Disabled;
        break;
      default:
        throw new Error(`Invalid policy value for ${JSON.stringify(policyDefinition)}: ${policy.value}`);
    }
  }
  return {
    policyAllowFeedback: (_d = policies[FeedbackTypes.ComplianceMapping.policyAllowFeedback.settingId]) != null ? _d : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowLimitedFeedback: (_e = policies[FeedbackTypes.ComplianceMapping.policyAllowLimitedFeedback.settingId]) != null ? _e : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowCopilotFeedback: (_f = policies[FeedbackTypes.ComplianceMapping.policyAllowCopilotFeedback.settingId]) != null ? _f : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowSurvey: (_g = policies[FeedbackTypes.ComplianceMapping.policyAllowSurvey.settingId]) != null ? _g : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowScreenshot: (_h = policies[FeedbackTypes.ComplianceMapping.policyAllowScreenshot.settingId]) != null ? _h : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowContact: (_i = policies[FeedbackTypes.ComplianceMapping.policyAllowContact.settingId]) != null ? _i : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowContent: (_j = policies[FeedbackTypes.ComplianceMapping.policyAllowContent.settingId]) != null ? _j : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyEmailCollectionDefault: (_k = policies[FeedbackTypes.ComplianceMapping.policyEmailCollectionDefault.settingId]) != null ? _k : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyScreenshotDefault: (_l = policies[FeedbackTypes.ComplianceMapping.policyScreenshotDefault.settingId]) != null ? _l : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policySendPublicFeedback: (_m = policies[FeedbackTypes.ComplianceMapping.policySendPublicFeedback.settingId]) != null ? _m : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyContentSamplesDefault: (_n = policies[FeedbackTypes.ComplianceMapping.policyContentSamplesDefault.settingId]) != null ? _n : FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    optionalConnectedExperiences: (_o = policies[FeedbackTypes.ComplianceMapping.optionalConnectedExperiences.settingId]) != null ? _o : FeedbackTypes.FeedbackPolicyValue.NotConfigured
  };
};
const lookupCloudPolicyServicePolicies = (cachedPolicies, tenantCloudType, authorization, callerAppHint) => __async(void 0, null, function* () {
  const baseLogMeta = {
    tenantCloudType
  };
  const authorizationHeader = authorization.startsWith("Bearer") ? authorization : `Bearer ${authorization}`;
  const uri = getUri(tenantCloudType);
  const xcid = (0,v4["default"])();
  const errorContext = (0,logging.newErrorContext)();
  const startTime = Date.now();
  try {
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudPolicyServiceRequestSendImminent, "About to Send Request to Cloud Policy Service", __spreadProps(__spreadValues({}, baseLogMeta), {
      httpElapsedRequestTimeMs: Date.now() - startTime,
      httpStatusCode: errorContext.httpStatusCode,
      httpStatusText: errorContext.httpStatusText
    }));
    const response = yield fetch(uri, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: authorizationHeader,
        "x-Cid": xcid,
        CallerAppHint: callerAppHint
      }
    });
    errorContext.httpStatusCode = response.status;
    errorContext.httpStatusText = response.statusText;
    if (!response.ok && response.status !== 404) {
      throw new Error(`Failed to fetch policies from CPS: ${response.status}: ${response.statusText}`);
    }
    const checkInIntervalHeader = response.headers.get("Checkin-Interval");
    const checkInInterval = checkInIntervalHeader ? parseInt(checkInIntervalHeader, 10) : NO_POLICIES_CHECK_INTERVAL;
    if (response.status === 404 || response.status === 204) {
      return {
        nextCheckTime: Date.now() + checkInInterval * 1e3 * 60,
        policies: getUnconfiguredPolicies()
      };
    }
    const responseBody = yield response.json();
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudPolicyServiceRequestSuccess, "Cloud Policy Service Request Success", __spreadProps(__spreadValues({}, baseLogMeta), {
      httpElapsedRequestTimeMs: Date.now() - startTime,
      httpStatusCode: errorContext.httpStatusCode,
      httpStatusText: errorContext.httpStatusText
    }));
    return {
      nextCheckTime: Date.now() + checkInInterval * 1e3 * 60,
      policies: parsePolicies(responseBody)
    };
  } catch (err) {
    (0,logging.LogError)(LoggingTypes.LoggingTags.CloudPolicyServiceRequestFailed, "Cloud Policy Service Request Failed", err, __spreadProps(__spreadValues({}, baseLogMeta), {
      httpElapsedRequestTimeMs: Date.now() - startTime,
      httpStatusCode: errorContext.httpStatusCode,
      httpStatusText: errorContext.httpStatusText
    }));
    if (cachedPolicies) {
      (0,logging.LogInfo)(LoggingTypes.LoggingTags.GetCloudPolicyServicePoliciesFallbackCached, "Falling back to cached policies", __spreadValues({}, baseLogMeta));
      return __spreadValues({}, cachedPolicies);
    }
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.GetCloudPolicyServicePoliciesFallbackDefault, "Using default policies", __spreadValues({}, baseLogMeta));
    return {
      nextCheckTime: Date.now(),
      policies: getDefaultPolicies()
    };
  }
});
const getDefaultPolicies = () => {
  return {
    policyAllowFeedback: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyAllowLimitedFeedback: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyAllowCopilotFeedback: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyAllowSurvey: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyAllowScreenshot: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyAllowContact: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyAllowContent: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyEmailCollectionDefault: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyScreenshotDefault: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policySendPublicFeedback: FeedbackTypes.FeedbackPolicyValue.Disabled,
    policyContentSamplesDefault: FeedbackTypes.FeedbackPolicyValue.Disabled,
    optionalConnectedExperiences: FeedbackTypes.FeedbackPolicyValue.Disabled
  };
};
const getUnconfiguredPolicies = () => {
  return {
    policyAllowFeedback: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowLimitedFeedback: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowCopilotFeedback: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowSurvey: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowScreenshot: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowContact: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowContent: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyEmailCollectionDefault: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyScreenshotDefault: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policySendPublicFeedback: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyContentSamplesDefault: FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    optionalConnectedExperiences: FeedbackTypes.FeedbackPolicyValue.NotConfigured
  };
};
const getCloudPolicyServicePolicies = (tenantCloudType, authorization, userId, callerAppHint) => __async(void 0, null, function* () {
  const baseLogMeta = {
    tenantCloudType
  };
  (0,logging.LogInfo)(LoggingTypes.LoggingTags.GetCloudPolicyServicePoliciesInvoked, "getCloudPolicyServicePolicies() invoked", __spreadValues({}, baseLogMeta));
  const inner = () => __async(void 0, null, function* () {
    let cachedPolicies = void 0;
    if (cloudPoliciesCache().has(userId)) {
      cachedPolicies = cloudPoliciesCache().get(userId);
      if (cachedPolicies && Date.now() < cachedPolicies.nextCheckTime) {
        (0,logging.LogInfo)(LoggingTypes.LoggingTags.GetCloudPolicyServicePoliciesCached, "Returning cached policies", __spreadProps(__spreadValues({}, baseLogMeta), {
          nextCheckTime: cachedPolicies.nextCheckTime
        }));
        return cachedPolicies.policies;
      }
    }
    const value = yield lookupCloudPolicyServicePolicies(cachedPolicies, tenantCloudType, authorization, callerAppHint);
    cloudPoliciesCache().set(userId, value);
    return value.policies;
  });
  if (navigator.locks) {
    return yield navigator.locks.request("inAppFeedbackCloudPoliciesLock", inner);
  }
  return yield inner();
});
;// ./functions/internal/SupportFunctions.ts


function SupportFunctions_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function SupportFunctions_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, SupportFunctions_toPropertyKey(o.key), o); } }
function SupportFunctions_createClass(e, r, t) { return r && SupportFunctions_defineProperties(e.prototype, r), t && SupportFunctions_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function SupportFunctions_toPropertyKey(t) { var i = SupportFunctions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SupportFunctions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const isScenarioEnabled = scenarioConfig => {
  var _a, _b, _c, _d, _e, _f, _g;
  if (!scenarioConfig || !(scenarioConfig == null ? void 0 : scenarioConfig.isScenarioEnabled)) {
    return false;
  }
  if (scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.CrashImpact || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.Experience || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.ProductSatisfaction || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.ResponsibleAI || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AIError || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AIGeneral || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AIThumbsDown || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AIThumbsUp || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.PromptSuggestion) {
    return true;
  }
  if (scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.FeatureArea && ((_a = scenarioConfig.questionDetails) == null ? void 0 : _a.questionOptions) && ((_b = scenarioConfig.questionDetails) == null ? void 0 : _b.questionOptions.length) > 0) {
    return true;
  }
  if ((scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.Custom || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AICustom) && ((_c = scenarioConfig.questionDetails) == null ? void 0 : _c.questionUiType) === FeedbackTypes.InAppFeedbackQuestionUiType.Text) {
    return true;
  }
  if ((scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.Custom || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AICustom) && ((_d = scenarioConfig.questionDetails) == null ? void 0 : _d.questionUiType) && ((_e = scenarioConfig.questionDetails) == null ? void 0 : _e.questionInstruction) && ((_f = scenarioConfig.questionDetails) == null ? void 0 : _f.questionOptions) && ((_g = scenarioConfig.questionDetails) == null ? void 0 : _g.questionOptions.length) > 0) {
    return true;
  }
  return false;
};
const isAIScenario = scenarioConfig => {
  if (!isScenarioEnabled(scenarioConfig)) {
    return false;
  }
  if ((scenarioConfig == null ? void 0 : scenarioConfig.scenarioType) !== FeedbackTypes.InAppFeedbackScenarioType.AIError && (scenarioConfig == null ? void 0 : scenarioConfig.scenarioType) !== FeedbackTypes.InAppFeedbackScenarioType.AIGeneral && (scenarioConfig == null ? void 0 : scenarioConfig.scenarioType) !== FeedbackTypes.InAppFeedbackScenarioType.AIThumbsDown && (scenarioConfig == null ? void 0 : scenarioConfig.scenarioType) !== FeedbackTypes.InAppFeedbackScenarioType.AIThumbsUp && (scenarioConfig == null ? void 0 : scenarioConfig.scenarioType) !== FeedbackTypes.InAppFeedbackScenarioType.PromptSuggestion && (scenarioConfig == null ? void 0 : scenarioConfig.scenarioType) !== FeedbackTypes.InAppFeedbackScenarioType.AICustom) {
    return false;
  }
  return true;
};
const isAIThumbsScenarioType = (scenarioConfig, feedbackType) => {
  if (!(scenarioConfig == null ? void 0 : scenarioConfig.isScenarioEnabled)) {
    return false;
  }
  if (scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AIThumbsUp || scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AIThumbsDown) {
    return true;
  }
  if (scenarioConfig.scenarioType === FeedbackTypes.InAppFeedbackScenarioType.AICustom && isThumbsFeedbackType(feedbackType)) {
    return true;
  }
  return false;
};
const isThumbsFeedbackType = feedbackType => {
  if (feedbackType === FeedbackTypes.FeedbackType.ThumbsUp || feedbackType === FeedbackTypes.FeedbackType.ThumbsDown) {
    return true;
  }
  return false;
};
const _ScreenCapturer = function () {
  function _ScreenCapturer() {
    SupportFunctions_classCallCheck(this, _ScreenCapturer);
  }
  return SupportFunctions_createClass(_ScreenCapturer, null, [{
    key: "isSupported",
    value: function isSupported() {
      var _a;
      return (!!((_a = navigator.mediaDevices) == null ? void 0 : _a.getDisplayMedia) && typeof MediaRecorder !== "undefined" && !!_ScreenCapturer.getSupportedMimeType()
      );
    }
  }, {
    key: "getSupportedMimeType",
    value: function getSupportedMimeType() {
      const [recordingTypeInfo] = _ScreenCapturer.SUPPORTED_RECORDING_TYPES.filter(({
        recordingMimeType
      }) => MediaRecorder.isTypeSupported(recordingMimeType));
      if (recordingTypeInfo) {
        return {
          recording: recordingTypeInfo.recordingMimeType,
          blob: recordingTypeInfo.recordedBlobType
        };
      }
      return null;
    }
  }]);
}();
_ScreenCapturer.SUPPORTED_RECORDING_TYPES = [{
  recordingMimeType: "video/webm; codecs=vp9",
  recordedBlobType: "video/webm"
}, {
  recordingMimeType: "video/webm; codecs=vp8",
  recordedBlobType: "video/webm"
}, {
  recordingMimeType: "video/mp4",
  recordedBlobType: "video/mp4"
}];
let ScreenCapturer = _ScreenCapturer;
;// ./functions/internal/Policies.ts






const cloudTypeDisabledPolicies = {
  policyAllowFeedback: [FeedbackTypes.TenantCloudType.UsGov, FeedbackTypes.TenantCloudType.UsGovDod, FeedbackTypes.TenantCloudType.UsNat, FeedbackTypes.TenantCloudType.UsSec],
  policyAllowLimitedFeedback: [FeedbackTypes.TenantCloudType.UsGov, FeedbackTypes.TenantCloudType.UsGovDod, FeedbackTypes.TenantCloudType.UsNat, FeedbackTypes.TenantCloudType.UsSec],
  policyAllowContact: [FeedbackTypes.TenantCloudType.GccMod, FeedbackTypes.TenantCloudType.UsGov, FeedbackTypes.TenantCloudType.UsGovDod],
  policyAllowScreenshot: [FeedbackTypes.TenantCloudType.GccMod, FeedbackTypes.TenantCloudType.UsGov, FeedbackTypes.TenantCloudType.UsGovDod],
  policyAllowContent: [FeedbackTypes.TenantCloudType.GccMod, FeedbackTypes.TenantCloudType.UsGov, FeedbackTypes.TenantCloudType.UsGovDod],
  policySendPublicFeedback: [FeedbackTypes.TenantCloudType.GccMod, FeedbackTypes.TenantCloudType.UsGov, FeedbackTypes.TenantCloudType.UsGovDod]
};
const cloudTypeExplicitEnabledOnly = [FeedbackTypes.TenantCloudType.GccMod, FeedbackTypes.TenantCloudType.UsGov, FeedbackTypes.TenantCloudType.UsGovDod];
const isEnabledByPolicy = policy => {
  return policy === FeedbackTypes.FeedbackPolicyValue.Enabled || policy === FeedbackTypes.FeedbackPolicyValue.NotConfigured || policy === FeedbackTypes.FeedbackPolicyValue.NotApplicable;
};
const isDisabledByCloudPolicy = (policy, tenantCloudType) => {
  if (!tenantCloudType) {
    return false;
  }
  const cloudPolicy = cloudTypeDisabledPolicies[policy];
  if (cloudPolicy && cloudPolicy.includes(tenantCloudType)) {
    return true;
  }
  return false;
};
var DefaultState = (DefaultState2 => {
  DefaultState2[DefaultState2["Enabled"] = FeedbackTypes.FeedbackPolicyValue.Enabled] = "Enabled";
  DefaultState2[DefaultState2["Disabled"] = FeedbackTypes.FeedbackPolicyValue.Disabled] = "Disabled";
  return DefaultState2;
})(DefaultState || {});
const isFeatureEnabled = (policy, defaultState = DefaultState.Disabled) => {
  if (policy === FeedbackTypes.FeedbackPolicyValue.Enabled) {
    return true;
  }
  if (policy === FeedbackTypes.FeedbackPolicyValue.Disabled) {
    return false;
  }
  if (defaultState === DefaultState.Enabled) {
    return true;
  }
  return false;
};
const isFeatureDisabled = (policy, defaultState) => {
  return !isFeatureEnabled(policy, defaultState);
};
const isPolicyMissing = policy => {
  return policy === void 0 || policy === FeedbackTypes.FeedbackPolicyValue.NotApplicable;
};
const isExplicitEmailEnabled = initOptions => {
  var _a, _b;
  const policy = "policyAllowContact";
  const {
    feedbackConfig
  } = initOptions;
  if (!(feedbackConfig == null ? void 0 : feedbackConfig.isEmailCollectionEnabled)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_a = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _a.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b[policy]);
  }
  return true;
};
const isImplicitEmailEnabled = initOptions => {
  var _a, _b, _c;
  const policy = "policyAllowContact";
  const {
    feedbackConfig
  } = initOptions;
  if (feedbackConfig == null ? void 0 : feedbackConfig.isEmailCollectionEnabled) {
    return false;
  }
  if (!((_a = initOptions.feedbackConfig) == null ? void 0 : _a.email)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_c = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _c[policy]);
  }
  return true;
};
const getEmailConsentType = initOptions => {
  if (isExplicitEmailEnabled(initOptions)) {
    return FeedbackTypes.EmailConsentRequestType.Explicit;
  }
  if (isImplicitEmailEnabled(initOptions)) {
    return FeedbackTypes.EmailConsentRequestType.Implicit;
  }
  return FeedbackTypes.EmailConsentRequestType.NotRequested;
};
const getOcvEmailConsentType = (initOptions, _email, isEmailSelected) => {
  const consentType = getEmailConsentType(initOptions);
  switch (consentType) {
    case FeedbackTypes.EmailConsentRequestType.NotRequested:
      return FeedbackTypes.EmailConsentType.NotRequested;
    case FeedbackTypes.EmailConsentRequestType.Implicit:
      return FeedbackTypes.EmailConsentType.Implicit;
    case FeedbackTypes.EmailConsentRequestType.Explicit:
      return isEmailSelected ? FeedbackTypes.EmailConsentType.Explicit : FeedbackTypes.EmailConsentType.None;
  }
};
const canSendEmailToOcv = (initOptions, email, isEmailSelected) => {
  if (!email) {
    return false;
  }
  const consentType = getEmailConsentType(initOptions);
  switch (consentType) {
    case FeedbackTypes.EmailConsentRequestType.NotRequested:
      return false;
    case FeedbackTypes.EmailConsentRequestType.Implicit:
      return true;
    case FeedbackTypes.EmailConsentRequestType.Explicit:
      return isEmailSelected ? true : false;
  }
};
const isExplicitConsentForEmailProvided = (initOptions, email, isEmailSelected) => {
  if (!email) {
    return false;
  }
  const consentType = getEmailConsentType(initOptions);
  switch (consentType) {
    case FeedbackTypes.EmailConsentRequestType.NotRequested:
    case FeedbackTypes.EmailConsentRequestType.Implicit:
      return false;
    case FeedbackTypes.EmailConsentRequestType.Explicit:
      return isEmailSelected ? true : false;
  }
};
const isFileUploadEnabled = initOptions => {
  var _a, _b;
  const policy = "policyAllowScreenshot";
  const {
    feedbackConfig
  } = initOptions;
  if (!(feedbackConfig == null ? void 0 : feedbackConfig.isFileUploadEnabled)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_a = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _a.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b[policy]);
  }
  return true;
};
const isReproductionModeEnabled = initOptions => {
  var _a, _b, _c;
  const policy = "policyAllowContent";
  const {
    feedbackConfig
  } = initOptions;
  if (!((_a = feedbackConfig == null ? void 0 : feedbackConfig.reproductionModeConfig) == null ? void 0 : _a.isReproductionModeEnabled)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_c = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _c[policy]);
  }
  return true;
};
const isPublicFeedbackEnabled = initOptions => {
  var _a, _b;
  const policy = "policySendPublicFeedback";
  const {
    feedbackConfig
  } = initOptions;
  if (!(feedbackConfig == null ? void 0 : feedbackConfig.isPublicFeedbackEnabled)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_a = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _a.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b[policy]);
  }
  return true;
};
const isScreenshotEnabled = initOptions => {
  var _a, _b;
  const policy = "policyAllowScreenshot";
  const {
    feedbackConfig
  } = initOptions;
  if (!(feedbackConfig == null ? void 0 : feedbackConfig.isScreenshotEnabled)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_a = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _a.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b[policy]);
  }
  return true;
};
const isScreenRecordingEnabled = initOptions => {
  var _a, _b;
  const policy = "policyAllowScreenshot";
  const {
    feedbackConfig
  } = initOptions;
  if (!(feedbackConfig == null ? void 0 : feedbackConfig.isScreenRecordingEnabled) || !ScreenCapturer.isSupported()) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_a = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _a.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b[policy]);
  }
  return true;
};
const isShareContextDataEnabled = initOptions => {
  var _a, _b, _c, _d;
  const policy = "policyAllowContent";
  if (!initOptions.feedbackConfig) {
    return false;
  }
  const {
    diagnosticsConfig
  } = initOptions.feedbackConfig;
  if (!(diagnosticsConfig == null ? void 0 : diagnosticsConfig.isShareContextDataEnabled) || !(diagnosticsConfig == null ? void 0 : diagnosticsConfig.getContextData)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_b = (_a = initOptions.feedbackConfig) == null ? void 0 : _a.complianceChecks) == null ? void 0 : _b.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_d = (_c = initOptions.feedbackConfig) == null ? void 0 : _c.complianceChecks) == null ? void 0 : _d[policy]);
  }
  return true;
};
const isHostManagedContextDataEnabled = initOptions => {
  var _a, _b, _c, _d;
  const policy = "policyAllowContent";
  if (!initOptions.feedbackConfig) {
    return false;
  }
  const {
    diagnosticsConfig
  } = initOptions.feedbackConfig;
  if (!(diagnosticsConfig == null ? void 0 : diagnosticsConfig.isHostManagedContextDataEnabled) || !(diagnosticsConfig == null ? void 0 : diagnosticsConfig.hostManagedContextDataExplanationUrl) || !(diagnosticsConfig == null ? void 0 : diagnosticsConfig.extractFeedbackDataForHost)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_b = (_a = initOptions.feedbackConfig) == null ? void 0 : _a.complianceChecks) == null ? void 0 : _b.tenantCloudType)) {
    return false;
  }
  if ((initOptions == null ? void 0 : initOptions.authenticationType) === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_d = (_c = initOptions.feedbackConfig) == null ? void 0 : _c.complianceChecks) == null ? void 0 : _d[policy]);
  }
  return true;
};
const isHostManagedContextDataEnabledForAiParams = initOptions => {
  var _a, _b, _c, _d, _e;
  const policy = "policyAllowContent";
  if (!isAIScenario((_a = initOptions == null ? void 0 : initOptions.feedbackConfig) == null ? void 0 : _a.scenarioConfig) || !(initOptions == null ? void 0 : initOptions.userData)) {
    return false;
  }
  if (isDisabledByCloudPolicy(policy, (_c = (_b = initOptions.feedbackConfig) == null ? void 0 : _b.complianceChecks) == null ? void 0 : _c.tenantCloudType)) {
    return false;
  }
  if ((initOptions == null ? void 0 : initOptions.authenticationType) === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return isEnabledByPolicy((_e = (_d = initOptions.feedbackConfig) == null ? void 0 : _d.complianceChecks) == null ? void 0 : _e[policy]);
  }
  return true;
};
const isOptionalConnectedExperiencesEnabled = initOptions => {
  var _a, _b, _c, _d;
  const {
    feedbackConfig
  } = initOptions;
  if (isDisabledByCloudPolicy("optionalConnectedExperiences", (_a = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _a.tenantCloudType)) {
    return false;
  }
  if (isDisabledByCloudPolicy("policySendPublicFeedback", (_b = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _b.tenantCloudType)) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.Unauthenticated) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.MSA) {
    return initOptions.ageGroup === FeedbackTypes.FeedbackAgeGroup.Adult || initOptions.ageGroup === FeedbackTypes.FeedbackAgeGroup.Undefined || initOptions.ageGroup === void 0;
  }
  if (isFeatureDisabled((_c = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _c.optionalConnectedExperiences, DefaultState.Enabled)) {
    return false;
  }
  if (isFeatureDisabled((_d = feedbackConfig == null ? void 0 : feedbackConfig.complianceChecks) == null ? void 0 : _d.policySendPublicFeedback, DefaultState.Enabled)) {
    return false;
  }
  return true;
};
const isSelectEmailCollectionDefault = initOptions => {
  var _a, _b;
  if (!isExplicitEmailEnabled(initOptions)) {
    return false;
  }
  if ((initOptions == null ? void 0 : initOptions.authenticationType) === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return ((_b = (_a = initOptions.feedbackConfig) == null ? void 0 : _a.complianceChecks) == null ? void 0 : _b.policyEmailCollectionDefault) === FeedbackTypes.FeedbackPolicyValue.Enabled;
  }
  return false;
};
const isSelectScreenshotDefault = initOptions => {
  var _a, _b, _c, _d, _e, _f;
  if (!isScreenshotEnabled(initOptions) || ((_b = (_a = initOptions.feedbackConfig) == null ? void 0 : _a.screenshotInfo) == null ? void 0 : _b.screenshotBase64) === void 0) {
    return false;
  }
  if (initOptions.authenticationType === FeedbackTypes.FeedbackAuthenticationType.MSA && initOptions.feedbackConfig.organizationKey === FeedbackTypes.OrganizationKey.WINDOWSSYS) {
    return true;
  }
  if ((initOptions == null ? void 0 : initOptions.authenticationType) === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    const defaultState = isAIScenario((_c = initOptions.feedbackConfig) == null ? void 0 : _c.scenarioConfig) ? DefaultState.Enabled : DefaultState.Disabled;
    return isFeatureEnabled((_e = (_d = initOptions.feedbackConfig) == null ? void 0 : _d.complianceChecks) == null ? void 0 : _e.policyScreenshotDefault, defaultState);
  }
  if (isAIScenario((_f = initOptions.feedbackConfig) == null ? void 0 : _f.scenarioConfig)) {
    return true;
  }
  return false;
};
const isSelectShareContextDataDefault = initOptions => {
  var _a, _b, _c, _d, _e, _f;
  if (!isShareContextDataEnabled(initOptions)) {
    return false;
  }
  if (((_a = initOptions.feedbackConfig) == null ? void 0 : _a.organizationKey) === FeedbackTypes.OrganizationKey.CAI || ((_b = initOptions.feedbackConfig) == null ? void 0 : _b.privacyConsentBlockKey) === FeedbackTypes.PrivacyConsentBlockKey.CAI) {
    return false;
  }
  if ((initOptions == null ? void 0 : initOptions.authenticationType) === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    const defaultState = isAIScenario((_c = initOptions.feedbackConfig) == null ? void 0 : _c.scenarioConfig) ? DefaultState.Enabled : DefaultState.Disabled;
    return isFeatureEnabled((_e = (_d = initOptions.feedbackConfig) == null ? void 0 : _d.complianceChecks) == null ? void 0 : _e.policyContentSamplesDefault, defaultState);
  }
  if (isAIScenario((_f = initOptions.feedbackConfig) == null ? void 0 : _f.scenarioConfig)) {
    return true;
  }
  return false;
};
const isSelectHostManagedContextDataDefault = initOptions => {
  var _a, _b, _c, _d, _e, _f;
  if (!isHostManagedContextDataEnabled(initOptions) && !isHostManagedContextDataEnabledForAiParams(initOptions)) {
    return false;
  }
  if (((_a = initOptions.feedbackConfig) == null ? void 0 : _a.organizationKey) === FeedbackTypes.OrganizationKey.CAI || ((_b = initOptions.feedbackConfig) == null ? void 0 : _b.privacyConsentBlockKey) === FeedbackTypes.PrivacyConsentBlockKey.CAI) {
    return false;
  }
  if ((initOptions == null ? void 0 : initOptions.authenticationType) === FeedbackTypes.FeedbackAuthenticationType.AAD) {
    const defaultState = isAIScenario((_c = initOptions.feedbackConfig) == null ? void 0 : _c.scenarioConfig) ? DefaultState.Enabled : DefaultState.Disabled;
    return isFeatureEnabled((_e = (_d = initOptions.feedbackConfig) == null ? void 0 : _d.complianceChecks) == null ? void 0 : _e.policyContentSamplesDefault, defaultState);
  }
  if (isAIScenario((_f = initOptions.feedbackConfig) == null ? void 0 : _f.scenarioConfig)) {
    return true;
  }
  return false;
};
const getPolicyFeatureSettings = initOptions => {
  return {
    emailCollectionConsentType: getEmailConsentType(initOptions),
    isFileUploadEnabled: isFileUploadEnabled(initOptions),
    isScreenshotEnabled: isScreenshotEnabled(initOptions),
    isScreenRecordingEnabled: isScreenRecordingEnabled(initOptions),
    isShareContextDataEnabled: isShareContextDataEnabled(initOptions),
    isHostManagedContextDataEnabled: isHostManagedContextDataEnabled(initOptions) || isHostManagedContextDataEnabledForAiParams(initOptions),
    isOptionalConnectedExperiencesEnabled: isOptionalConnectedExperiencesEnabled(initOptions),
    isSelectEmailCollectionDefault: isSelectEmailCollectionDefault(initOptions),
    isSelectScreenshotDefault: isSelectScreenshotDefault(initOptions),
    isSelectShareContextDataDefault: isSelectShareContextDataDefault(initOptions),
    isSelectHostManagedContextDataDefault: isSelectHostManagedContextDataDefault(initOptions),
    isReproductionModeEnabled: isReproductionModeEnabled(initOptions),
    isPublicFeedbackEnabled: isPublicFeedbackEnabled(initOptions)
  };
};
const mustTreatNotConfiguredAsDisabled = tenantCloudType => {
  return tenantCloudType && cloudTypeExplicitEnabledOnly.includes(tenantCloudType);
};
const isFeedbackDisabled = (initOptions, shouldLog) => {
  const {
    ageGroup,
    authenticationType,
    feedbackConfig
  } = initOptions || {};
  const {
    scenarioConfig,
    complianceChecks
  } = feedbackConfig || {};
  const {
    policyAllowFeedback,
    policyAllowCopilotFeedback,
    tenantCloudType
  } = complianceChecks || {};
  if (authenticationType === FeedbackTypes.FeedbackAuthenticationType.MSA) {
    if (ageGroup === FeedbackTypes.FeedbackAgeGroup.MinorWithoutParentalConsent || ageGroup === FeedbackTypes.FeedbackAgeGroup.MinorWithParentalConsent || ageGroup === FeedbackTypes.FeedbackAgeGroup.MinorNoParentalConsentRequired) {
      shouldLog && (0,logging.LogInfo)(LoggingTypes.LoggingTags.FeedbackDisabledReason, "Feedback disabled for minor", {});
      return true;
    }
  }
  if (isDisabledByCloudPolicy("policyAllowFeedback", tenantCloudType) && isDisabledByCloudPolicy("policyAllowLimitedFeedback", tenantCloudType)) {
    shouldLog && (0,logging.LogInfo)(LoggingTypes.LoggingTags.FeedbackDisabledReason, "Feedback disabled because of sovereign cloud rules", {});
    return true;
  }
  if (isPolicyMissing(policyAllowFeedback)) {
    return false;
  }
  if (authenticationType !== FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return false;
  }
  if (isAIThumbsScenarioType(scenarioConfig, feedbackConfig == null ? void 0 : feedbackConfig.initialFeedbackType)) {
    if (isFeedbackLiteEnabledByPolicies(complianceChecks, true)) {
      return false;
    }
  }
  if (isAIScenario(scenarioConfig)) {
    if (policyAllowCopilotFeedback === FeedbackTypes.FeedbackPolicyValue.Enabled) {
      return false;
    }
    if (policyAllowCopilotFeedback === FeedbackTypes.FeedbackPolicyValue.Disabled) {
      shouldLog && (0,logging.LogInfo)(LoggingTypes.LoggingTags.FeedbackDisabledReason, "Feedback disabled because feedback is for Copilot scenario and Copilot feedback policy is disabled", {});
      return true;
    }
  }
  if (mustTreatNotConfiguredAsDisabled(tenantCloudType) && policyAllowFeedback !== FeedbackTypes.FeedbackPolicyValue.Enabled) {
    shouldLog && (0,logging.LogInfo)(LoggingTypes.LoggingTags.FeedbackDisabledReason, "Feedback disabled because feedback only allowed in this sovereign cloud if explicitly enabled", {});
    return true;
  }
  if (policyAllowFeedback === FeedbackTypes.FeedbackPolicyValue.Disabled) {
    shouldLog && (0,logging.LogInfo)(LoggingTypes.LoggingTags.FeedbackDisabledReason, "Feedback disabled because feedback policy is disabled", {});
    return true;
  }
  return false;
};
const isFeedbackLiteEnabledByPolicies = (complianceChecks, aIThumbsScenario = false) => {
  if (!aIThumbsScenario) {
    return false;
  }
  const policyValueWhenNotConfigured = (policy, valueIfNotConfigured) => {
    if (policy === FeedbackTypes.FeedbackPolicyValue.NotConfigured) {
      return valueIfNotConfigured;
    }
    return policy;
  };
  let {
    policyAllowFeedback = FeedbackTypes.FeedbackPolicyValue.NotConfigured,
    policyAllowLimitedFeedback = FeedbackTypes.FeedbackPolicyValue.NotConfigured
  } = complianceChecks || {};
  if (!(complianceChecks == null ? void 0 : complianceChecks.tenantCloudType) || (complianceChecks == null ? void 0 : complianceChecks.tenantCloudType) === FeedbackTypes.TenantCloudType.Worldwide) {
    policyAllowFeedback = policyValueWhenNotConfigured(policyAllowFeedback, FeedbackTypes.FeedbackPolicyValue.Enabled);
    policyAllowLimitedFeedback = policyValueWhenNotConfigured(policyAllowLimitedFeedback, FeedbackTypes.FeedbackPolicyValue.Disabled);
  } else {
    policyAllowFeedback = policyValueWhenNotConfigured(policyAllowFeedback, FeedbackTypes.FeedbackPolicyValue.Disabled);
    policyAllowLimitedFeedback = policyValueWhenNotConfigured(policyAllowLimitedFeedback, FeedbackTypes.FeedbackPolicyValue.Disabled);
  }
  if ((complianceChecks == null ? void 0 : complianceChecks.policyAllowCopilotFeedback) === FeedbackTypes.FeedbackPolicyValue.Enabled) {
    return false;
  }
  if ((complianceChecks == null ? void 0 : complianceChecks.policyAllowCopilotFeedback) === FeedbackTypes.FeedbackPolicyValue.Disabled) {
    return policyAllowLimitedFeedback === FeedbackTypes.FeedbackPolicyValue.Enabled;
  }
  return policyAllowFeedback === FeedbackTypes.FeedbackPolicyValue.Disabled && policyAllowLimitedFeedback === FeedbackTypes.FeedbackPolicyValue.Enabled;
};
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(119);
;// ./functions/internal/TenantCloudTypeCache.ts




let _tenantCloudTypeCache = null;
const tenantCloudTypeCache = () => {
  if (_tenantCloudTypeCache === null) {
    _tenantCloudTypeCache = new PersistentCache(TENANT_CLOUD_TYPE_CACHE_KEY, MAX_CACHE_SIZE);
  }
  return _tenantCloudTypeCache;
};
;// ./functions/TenantCloudTypeUtils.ts


var TenantCloudTypeUtils_async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};




const basicFetchWithRetry = url => TenantCloudTypeUtils_async(void 0, null, function* () {
  let retriesRemaining = 2;
  while (retriesRemaining > 0) {
    try {
      const result = yield fetch(url);
      if (result.ok || result.status < 500) {
        return result;
      }
    } catch (e) {
      console.log(`Failed to make request for tenant cloud type: ${e}`);
    }
    retriesRemaining--;
  }
  throw new Error("Failed to fetch OpenID configuration");
});
const lookupTenantCloudType = tenantId => TenantCloudTypeUtils_async(void 0, null, function* () {
  const generalResult = yield basicFetchWithRetry(GET_GENERAL_OPEN_ID_CONFIGURATION(tenantId));
  if (generalResult.ok) {
    const generalResultJson = yield generalResult.json();
    if (generalResultJson.tenant_region_scope === "WW" || generalResultJson.tenant_region_scope === "NA" && !generalResultJson.tenant_region_sub_scope) {
      return FeedbackTypes.TenantCloudType.Worldwide;
    }
    if (generalResultJson.tenant_region_scope === "GCC") {
      return FeedbackTypes.TenantCloudType.GccMod;
    }
    if (generalResultJson.tenant_region_scope === "USGov" || generalResultJson.tenant_region_scope === "USG") {
      switch (generalResultJson.tenant_region_sub_scope) {
        case "DODCON":
          return FeedbackTypes.TenantCloudType.UsGov;
        case "DOD":
          return FeedbackTypes.TenantCloudType.UsGovDod;
      }
    }
    return;
  }
  const chinaResultPromise = basicFetchWithRetry(GET_CHINA_OPEN_ID_CONFIGURATION(tenantId));
  const chinaResult = yield chinaResultPromise;
  if (chinaResult.ok) {
    return FeedbackTypes.TenantCloudType.China;
  }
  return FeedbackTypes.TenantCloudType.Worldwide;
});
const getTenantCloudType = init => TenantCloudTypeUtils_async(void 0, null, function* () {
  if (init.authenticationType !== FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return null;
  }
  const inner = () => TenantCloudTypeUtils_async(void 0, null, function* () {
    const tenantId = init.tenantId;
    if (tenantCloudTypeCache().has(tenantId)) {
      return tenantCloudTypeCache().get(tenantId);
    }
    const value = yield lookupTenantCloudType(tenantId);
    tenantCloudTypeCache().set(tenantId, value);
    return value != null ? value : null;
  });
  if (navigator.locks) {
    return yield navigator.locks.request("inAppFeedbackTenantCloudTypeLock", inner);
  }
  return yield inner();
});
const getCentroUrl = cloudType => {
  var _a;
  return (_a = cloudType ? constants.CentroUrlTenantCloudTypeMap[cloudType] : constants.CentroUrlProd) != null ? _a : constants.CentroUrlProd;
};
;// ./functions/BootstrapFunctionality.ts


var BootstrapFunctionality_defProp = Object.defineProperty;
var BootstrapFunctionality_getOwnPropSymbols = Object.getOwnPropertySymbols;
var BootstrapFunctionality_hasOwnProp = Object.prototype.hasOwnProperty;
var BootstrapFunctionality_propIsEnum = Object.prototype.propertyIsEnumerable;
var BootstrapFunctionality_defNormalProp = (obj, key, value) => key in obj ? BootstrapFunctionality_defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var BootstrapFunctionality_spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (BootstrapFunctionality_hasOwnProp.call(b, prop)) BootstrapFunctionality_defNormalProp(a, prop, b[prop]);
  if (BootstrapFunctionality_getOwnPropSymbols) for (var prop of BootstrapFunctionality_getOwnPropSymbols(b)) {
    if (BootstrapFunctionality_propIsEnum.call(b, prop)) BootstrapFunctionality_defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var BootstrapFunctionality_async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};







const getPolicies = (init, token) => BootstrapFunctionality_async(void 0, null, function* () {
  var _a, _b;
  if (init.authenticationType !== FeedbackTypes.FeedbackAuthenticationType.AAD) {
    return {};
  }
  const baseLogMeta = {
    clientFeedbackId: (_a = init.clientFeedbackId) != null ? _a : null,
    tenantCloudType: (_b = init.feedbackConfig.complianceChecks.tenantCloudType) != null ? _b : null
  };
  if (token.tokenAudienceResult.supported) {
    if (token.token) {
      return getCloudPolicyServicePolicies(init.feedbackConfig.complianceChecks.tenantCloudType, token.token, init.userId, init.cloudPolicyServiceConfig.callerAppHint);
    } else {
      (0,logging.LogInfo)(LoggingTypes.LoggingTags.CanDisplayFeedbackMissingToken, "Token is missing but required", baseLogMeta);
      throw Error("Token is missing but required");
    }
  }
  return {
    tenantCloudType: init.feedbackConfig.complianceChecks.tenantCloudType
  };
});
function canDisplayFeedback(init, token, providingCPSPolicies = false) {
  return BootstrapFunctionality_async(this, null, function* () {
    var _a, _b, _c;
    (0,logging.initializeLogging)({
      centroEnvironmentBaseUrl: getCentroUrl((_b = (_a = init.feedbackConfig) == null ? void 0 : _a.complianceChecks) == null ? void 0 : _b.tenantCloudType),
      hostName: init.clientName
    });
    const baseLogMeta = {
      clientFeedbackId: (_c = init.clientFeedbackId) != null ? _c : null,
      withToken: !!token,
      providingCPSPolicies
    };
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.CanDisplayFeedbackInvoked, "canDisplayFeedback() invoked", BootstrapFunctionality_spreadValues({}, baseLogMeta));
    if (!providingCPSPolicies && policiesNotSet(init)) {
      if (!token) {
        const err = new Error("Token is required when not providing policies");
        (0,logging.LogError)(LoggingTypes.LoggingTags.CanDisplayFeedbackMissingToken, "canDisplayFeedback() invoked", err, BootstrapFunctionality_spreadValues({}, baseLogMeta));
        throw err;
      }
      const policies = yield getPolicies(init, token);
      init.feedbackConfig.complianceChecks = BootstrapFunctionality_spreadValues(BootstrapFunctionality_spreadValues({}, init.feedbackConfig.complianceChecks), policies);
    }
    init.feedbackConfig.canDisplayFeedbackCalled = true;
    return {
      canDisplay: !isFeedbackDisabled(init, true),
      init
    };
  });
}
const policiesNotSet = options => {
  var _a, _b;
  return ((_b = (_a = options.feedbackConfig) == null ? void 0 : _a.complianceChecks) == null ? void 0 : _b.policyAllowSurvey) === void 0;
};
function canDisplayFeedbackNonCPS(init) {
  return BootstrapFunctionality_async(this, null, function* () {
    var _a, _b, _c;
    (0,logging.initializeLogging)({
      centroEnvironmentBaseUrl: getCentroUrl((_b = (_a = init.feedbackConfig) == null ? void 0 : _a.complianceChecks) == null ? void 0 : _b.tenantCloudType),
      hostName: init.clientName
    });
    const baseLogMeta = {
      clientFeedbackId: (_c = init.clientFeedbackId) != null ? _c : null
    };
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.CanDisplayFeedbackInvoked, "canDisplayFeedbackNonCPS() invoked", BootstrapFunctionality_spreadValues({}, baseLogMeta));
    init.feedbackConfig.canDisplayFeedbackCalled = true;
    return {
      canDisplay: !isFeedbackDisabled(init, true),
      init
    };
  });
}
const getCloudPolicyServiceTokenAudience = init => {
  var _a, _b;
  if (init.authenticationType === FeedbackTypes.FeedbackAuthenticationType.Unauthenticated) {
    return {
      supported: false
    };
  }
  const tenantCloudType = (_b = (_a = init.feedbackConfig) == null ? void 0 : _a.complianceChecks) == null ? void 0 : _b.tenantCloudType;
  if (tenantCloudType === void 0) {
    return {
      supported: true,
      audience: CloudPolicyServiceWorldWideBaseUrl
    };
  }
  return getBaseCloudPolicyServiceToken(tenantCloudType);
};
// EXTERNAL MODULE: ../runtime/build/buildService.ts + 1 modules
var buildService = __webpack_require__(774);
;// ./functions/SupportFunctions.ts



const merge = (target, source) => {
  for (const key in source) {
    if (source[key] instanceof Object && key in target) {
      Object.assign(source[key], merge(target[key], source[key]));
    }
  }
  return Object.assign(target || {}, source);
};
const mergeObjects = (...objList) => objList.reduce(merge, {});
const noop = () => void 0;
const sendEventSignal = (eventName, data) => {
  const customEvent = new CustomEvent(eventName, {
    detail: data
  });
  window.dispatchEvent(customEvent);
};
const isLocalBuild = () => {
  var _a;
  const LocalBuildPrefix = "local";
  return !!((_a = buildService.buildService.buildNumber) == null ? void 0 : _a.includes(LocalBuildPrefix));
};
const segmentUnicodeRegex = /[\s\S]/gu;
const segmentUnicodeString = input => {
  var _a;
  return Array.from((_a = input.match(segmentUnicodeRegex)) != null ? _a : []);
};
const unicodeSafeSubstring = (input, len) => {
  if (!input) {
    return "";
  }
  if (len === 0) {
    return "";
  }
  if (len > input.length) {
    return input;
  }
  const unicodeGraphemes = segmentUnicodeString(input);
  let constructedString = "";
  let lengthAllowance = len;
  for (const grapheme of unicodeGraphemes) {
    if (grapheme.length > lengthAllowance) {
      break;
    }
    lengthAllowance -= grapheme.length;
    constructedString = `${constructedString}${grapheme}`;
  }
  return constructedString;
};
const DefaultRequestTimeout = 3e3;
const promiseWithTimeout = (event, promiseFunction, timeoutInMs = DefaultRequestTimeout) => {
  const timerPromise = new Promise((_resolve, reject) => {
    setTimeout(() => reject(new Error(`${event}: request timeout error`)), timeoutInMs);
  });
  return Promise.race([promiseFunction, timerPromise]);
};
;// ./functions/internal/CloudConfigCache.ts




let _cloudConfigCache = null;
const cloudConfigCache = () => {
  if (!_cloudConfigCache) {
    _cloudConfigCache = new PersistentCache(CLOUD_CONFIG_CACHE_KEY, MAX_CACHE_SIZE);
  }
  return _cloudConfigCache;
};
;// ./functions/config-service/ConfigService.ts


var ConfigService_defProp = Object.defineProperty;
var ConfigService_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ConfigService_hasOwnProp = Object.prototype.hasOwnProperty;
var ConfigService_propIsEnum = Object.prototype.propertyIsEnumerable;
var ConfigService_defNormalProp = (obj, key, value) => key in obj ? ConfigService_defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var ConfigService_spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (ConfigService_hasOwnProp.call(b, prop)) ConfigService_defNormalProp(a, prop, b[prop]);
  if (ConfigService_getOwnPropSymbols) for (var prop of ConfigService_getOwnPropSymbols(b)) {
    if (ConfigService_propIsEnum.call(b, prop)) ConfigService_defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var ConfigService_async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};




const CloudConfigBaseUrl = "https://cdn.config.centro.core.microsoft/config";
const createConfigFilters = (inAppFeedbackInitOptions, feature) => {
  var _a, _b, _c;
  return {
    feature,
    appId: (_a = inAppFeedbackInitOptions.appId) == null ? void 0 : _a.toString(),
    platform: ((_b = inAppFeedbackInitOptions.feedbackConfig) == null ? void 0 : _b.hostPlatform) || "Web",
    audience: (_c = inAppFeedbackInitOptions.telemetry) == null ? void 0 : _c.audience,
    userId: inAppFeedbackInitOptions.userId
  };
};
const getConfigFilters = (inAppFeedbackInitOptions, feature) => {
  const configFilters = createConfigFilters(inAppFeedbackInitOptions, feature);
  const filteredConfigFilters = Object.fromEntries(Object.entries(configFilters).filter(([_, value]) => value !== ""));
  return filteredConfigFilters;
};
function getConfigFromInitOptions(inAppFeedbackInitOptions, feature) {
  return ConfigService_async(this, null, function* () {
    const configFilters = getConfigFilters(inAppFeedbackInitOptions, feature);
    const config = yield getConfigs(configFilters);
    if (!config) {
      return void 0;
    }
    const keysToRemove = ["Csp", "OnboardedConsumers", "Version"];
    return Object.fromEntries(Object.entries(config).filter(([key]) => !keysToRemove.includes(key)));
  });
}
const getConfigs = filters => ConfigService_async(void 0, null, function* () {
  const cacheKey = JSON.stringify(filters);
  const value = getConfigFromCache(cacheKey);
  if (value) {
    return value;
  }
  (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudConfigInfo, `Config not available in cache`, {});
  return yield setConfigs(filters);
});
const setConfigs = filters => ConfigService_async(void 0, null, function* () {
  const cacheKey = JSON.stringify(filters);
  const inner = () => ConfigService_async(void 0, null, function* () {
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudConfigInfo, `Cache missed, fetching data from the server`, {});
    const value = yield fetchConfigs(filters);
    if (value && Object.keys(value).length > 0) {
      const cacheWithExpiry = {
        value,
        expiry: Date.now() + CLOUD_CONFIG_CACHE_TTL_IN_MINUTES * 60 * 1e3
      };
      cloudConfigCache().set(cacheKey, cacheWithExpiry);
    }
    return value;
  });
  if (navigator.locks) {
    return yield navigator.locks.request("inAppFeedbackCloudConfigLock", inner);
  }
  return yield inner();
});
const getConfigFromCache = cacheKey => {
  if (cloudConfigCache().has(cacheKey)) {
    const result = cloudConfigCache().get(cacheKey);
    if (Date.now() > result.expiry) {
      (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudConfigInfo, `Data in cache expired`, {});
      cloudConfigCache().delete(cacheKey);
      return null;
    }
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudConfigInfo, `Using config data from cache`, {});
    return result.value;
  }
  return null;
};
const fetchConfigs = filters => ConfigService_async(void 0, null, function* () {
  const configUrl = appendUrlParameters(CloudConfigBaseUrl, filters);
  try {
    (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudConfigRequestSendImminent, `Cloud Config Request Imminent`, {});
    const response = yield fetch(configUrl);
    if (!response.ok) {
      (0,logging.LogError)(LoggingTypes.LoggingTags.CloudConfigRequestError, `Cloud Config Request Error: Received status code ${response.status}`, new Error(), {});
      return void 0;
    }
    const data = yield response.json();
    if (data) {
      (0,logging.LogInfo)(LoggingTypes.LoggingTags.CloudConfigRequestSuccess, `Cloud Config Request Success`, ConfigService_spreadValues({}, data));
      return data;
    }
    (0,logging.LogError)(LoggingTypes.LoggingTags.CloudConfigError, `Undefined configuration data`, new Error(), {});
    return void 0;
  } catch (error) {
    (0,logging.LogError)(LoggingTypes.LoggingTags.CloudConfigRequestError, `Cloud Config Request Error while fetching configuration data`, error, {});
    return void 0;
  }
});
const appendUrlParameters = (baseUrl, filters) => {
  const url = new URL(baseUrl);
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value !== void 0 && value !== null) {
      url.searchParams.append(key, value.toString());
    }
  });
  return url.toString();
};
;// ./functions/index.ts









/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict';
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(190)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}
})(this, function ErrorStackParser(StackFrame) {
  'use strict';

  var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
  var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
  var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
  return {
    parse: function ErrorStackParser$$parse(error) {
      if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
        return this.parseOpera(error);
      } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
        return this.parseV8OrIE(error);
      } else if (error.stack) {
        return this.parseFFOrSafari(error);
      } else {
        throw new Error('Cannot parse given Error object');
      }
    },
    extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
      if (urlLike.indexOf(':') === -1) {
        return [urlLike];
      }
      var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
      var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
      return [parts[1], parts[2] || undefined, parts[3] || undefined];
    },
    parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(CHROME_IE_STACK_REGEXP);
      }, this);
      return filtered.map(function (line) {
        if (line.indexOf('(eval ') > -1) {
          line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(,.*$)/g, '');
        }
        var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').replace(/^.*?\s+/, '');
        var location = sanitizedLine.match(/ (\(.+\)$)/);
        sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
        var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
        var functionName = location && sanitizedLine || undefined;
        var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
        return new StackFrame({
          functionName: functionName,
          fileName: fileName,
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    },
    parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !line.match(SAFARI_NATIVE_CODE_REGEXP);
      }, this);
      return filtered.map(function (line) {
        if (line.indexOf(' > eval') > -1) {
          line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
        }
        if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
          return new StackFrame({
            functionName: line
          });
        } else {
          var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
          var matches = line.match(functionNameRegex);
          var functionName = matches && matches[1] ? matches[1] : undefined;
          var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
          return new StackFrame({
            functionName: functionName,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }
      }, this);
    },
    parseOpera: function ErrorStackParser$$parseOpera(e) {
      if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) {
        return this.parseOpera9(e);
      } else if (!e.stack) {
        return this.parseOpera10(e);
      } else {
        return this.parseOpera11(e);
      }
    },
    parseOpera9: function ErrorStackParser$$parseOpera9(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
      var lines = e.message.split('\n');
      var result = [];
      for (var i = 2, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);
        if (match) {
          result.push(new StackFrame({
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }
      return result;
    },
    parseOpera10: function ErrorStackParser$$parseOpera10(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
      var lines = e.stacktrace.split('\n');
      var result = [];
      for (var i = 0, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);
        if (match) {
          result.push(new StackFrame({
            functionName: match[3] || undefined,
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }
      return result;
    },
    parseOpera11: function ErrorStackParser$$parseOpera11(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
      }, this);
      return filtered.map(function (line) {
        var tokens = line.split('@');
        var locationParts = this.extractLocation(tokens.pop());
        var functionCall = tokens.shift() || '';
        var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^)]*\)/g, '') || undefined;
        var argsRaw;
        if (functionCall.match(/\(([^)]*)\)/)) {
          argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
        }
        var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
        return new StackFrame({
          functionName: functionName,
          args: args,
          fileName: locationParts[0],
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    }
  };
});

/***/ }),

/***/ 561:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ esm_browser_v4)
});

;// ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({
  randomUUID
});
;// ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/rng.js
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}
;// ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ const regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/validate.js

function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}
/* harmony default export */ const esm_browser_validate = (validate);
;// ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/stringify.js

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset);
  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }
  return uuid;
}
/* harmony default export */ const esm_browser_stringify = (stringify);
;// ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;
  if (buf) {
    offset = offset || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
/* harmony default export */ const esm_browser_v4 = (v4);

/***/ }),

/***/ 629:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LoggingTags: () => (/* binding */ LoggingTags)
/* harmony export */ });


var LoggingTags = (LoggingTags2 => {
  LoggingTags2["FeedbackInitDataValidationError"] = "532379";
  LoggingTags2["FeedbackIFrameInitDataValidationError"] = "533188";
  LoggingTags2["LogInfoUnavailable"] = "532380";
  LoggingTags2["LogErrorUnavailable"] = "532381";
  LoggingTags2["CentroInitializeFailed"] = "532383";
  LoggingTags2["CentroPreloadFeatureFailed"] = "532384";
  LoggingTags2["CentroBootstrapFailed"] = "532385";
  LoggingTags2["UnmountFeedbackUnavailable"] = "532387";
  LoggingTags2["UpdateFeedbackOptionsUnavailable"] = "532388";
  LoggingTags2["OpenFeedbackunavailable"] = "532389";
  LoggingTags2["OpenFeedbackInIFrameRequest"] = "533041";
  LoggingTags2["OpenFeedbackInIFrameComplete"] = "533042";
  LoggingTags2["FeedbackComponentInitializationCompleted"] = "532386";
  LoggingTags2["OpenFeedbackFormRequested"] = "532390";
  LoggingTags2["FeedbackInitiated"] = "532392";
  LoggingTags2["CentroRuntimeInitializeCompleted"] = "532444";
  LoggingTags2["CentroPreloadFeatureStarted"] = "532448";
  LoggingTags2["CentroPreloadFeatureCompleted"] = "532449";
  LoggingTags2["CanDisplayFeedbackInvoked"] = "538284";
  LoggingTags2["CanDisplayFeedbackMissingToken"] = "538285";
  LoggingTags2["GetCloudPolicyServicePoliciesInvoked"] = "538286";
  LoggingTags2["GetCloudPolicyServicePoliciesCached"] = "538287";
  LoggingTags2["CloudPolicyServiceRequestSendImminent"] = "538288";
  LoggingTags2["CloudPolicyServiceRequestSuccess"] = "538289";
  LoggingTags2["CloudPolicyServiceRequestFailed"] = "538290";
  LoggingTags2["GetCloudPolicyServicePoliciesFallbackCached"] = "538291";
  LoggingTags2["GetCloudPolicyServicePoliciesFallbackDefault"] = "538292";
  LoggingTags2["FeedbackDisabledReason"] = "538293";
  LoggingTags2["CpsCacheError"] = "540789";
  LoggingTags2["CloudConfigRequestSendImminent"] = "542087";
  LoggingTags2["CloudConfigInfo"] = "539882";
  LoggingTags2["CloudConfigRequestSuccess"] = "542088";
  LoggingTags2["CloudConfigError"] = "539883";
  LoggingTags2["CloudConfigTimeout"] = "543800";
  LoggingTags2["CloudConfigRequestError"] = "542095";
  return LoggingTags2;
})(LoggingTags || {});

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict';
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(190)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}
})(this, function (StackFrame) {
  return {
    backtrace: function StackGenerator$$backtrace(opts) {
      var stack = [];
      var maxStackSize = 10;
      if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
        maxStackSize = opts.maxStackSize;
      }
      var curr = arguments.callee;
      while (curr && stack.length < maxStackSize && curr['arguments']) {
        var args = new Array(curr['arguments'].length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = curr['arguments'][i];
        }
        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
          stack.push(new StackFrame({
            functionName: RegExp.$1 || undefined,
            args: args
          }));
        } else {
          stack.push(new StackFrame({
            args: args
          }));
        }
        try {
          curr = curr.caller;
        } catch (e) {
          break;
        }
      }
      return stack;
    }
  };
});

/***/ }),

/***/ 651:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HostPlatform: () => (/* reexport safe */ _HostTypes__WEBPACK_IMPORTED_MODULE_3__.HostPlatform),
/* harmony export */   InvalidFileSizeError: () => (/* reexport safe */ _internal_CustomErrors__WEBPACK_IMPORTED_MODULE_2__.InvalidFileSizeError),
/* harmony export */   InvalidFileValidationError: () => (/* reexport safe */ _internal_CustomErrors__WEBPACK_IMPORTED_MODULE_2__.InvalidFileValidationError),
/* harmony export */   LoggingTags: () => (/* reexport safe */ _LoggingTypes__WEBPACK_IMPORTED_MODULE_1__.LoggingTags),
/* harmony export */   MsoAppNames: () => (/* reexport safe */ _HostTypes__WEBPACK_IMPORTED_MODULE_3__.MsoAppNames),
/* harmony export */   WrappingError: () => (/* reexport safe */ _internal_CustomErrors__WEBPACK_IMPORTED_MODULE_2__.WrappingError)
/* harmony export */ });
/* harmony import */ var _InitializationPatternTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(520);
/* harmony import */ var _InitializationPatternTypes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_InitializationPatternTypes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _InitializationPatternTypes__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _InitializationPatternTypes__WEBPACK_IMPORTED_MODULE_0__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _LoggingTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(629);
/* harmony import */ var _internal_CustomErrors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(469);
/* harmony import */ var _HostTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32);







/***/ }),

/***/ 708:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

exports.SourceMapGenerator = __webpack_require__(876).SourceMapGenerator;
exports.SourceMapConsumer = __webpack_require__(941).SourceMapConsumer;
exports.SourceNode = __webpack_require__(776).SourceNode;

/***/ }),

/***/ 774:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  buildService: () => (/* binding */ buildService),
  moduleAndVersionInfo: () => (/* binding */ moduleAndVersionInfo)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/stacktrace-js@2.0.0/node_modules/stacktrace-js/stacktrace.js
var stacktrace = __webpack_require__(456);
;// ../runtime/build/devOnly.ts

function isHmr() {
  return stacktrace.getSync().find(f => f.functionName === "hotApply") !== void 0;
}
;// ../runtime/build/buildService.ts

const buildService = {
  isProduction: "production" === "production",
  isDevelopment: "development" === "production",
  isTest: "test" === "production",
  gitRev: 'a64d0198ea8f7c8b5863b7abc04bed8930a3a627',
  buildNumber: 'local_build',
  isHmr: isHmr,
  localeBundle: 'undefined',
  jestJUnitOutputName: ({"NODE_ENV":"production","GIT_REV":'a64d0198ea8f7c8b5863b7abc04bed8930a3a627',"BUILD_NUMBER":'local_build',"LOCALE_BUNDLE":'undefined',"MODULE_NAME":'ocv-inapp-feedback-shared',"BUNDLE_VARIANT":'undefined',"CENTRO_HVC_DATA":null}).JEST_JUNIT_OUTPUT_NAME,
  bundleVariant: 'undefined'
};
const moduleAndVersionInfo = `${'ocv-inapp-feedback-shared'}_${buildService.buildNumber || ""}`;

/***/ }),

/***/ 776:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var SourceMapGenerator = (__webpack_require__(876).SourceMapGenerator);
var util = __webpack_require__(254);
var REGEX_NEWLINE = /(\r?\n)/;
var NEWLINE_CODE = 10;
var isSourceNode = "$$$isSourceNode$$$";
function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
  this.children = [];
  this.sourceContents = {};
  this.line = aLine == null ? null : aLine;
  this.column = aColumn == null ? null : aColumn;
  this.source = aSource == null ? null : aSource;
  this.name = aName == null ? null : aName;
  this[isSourceNode] = true;
  if (aChunks != null) this.add(aChunks);
}
SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
  var node = new SourceNode();
  var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
  var shiftNextLine = function () {
    var lineContents = remainingLines.shift();
    var newLine = remainingLines.shift() || "";
    return lineContents + newLine;
  };
  var lastGeneratedLine = 1,
    lastGeneratedColumn = 0;
  var lastMapping = null;
  aSourceMapConsumer.eachMapping(function (mapping) {
    if (lastMapping !== null) {
      if (lastGeneratedLine < mapping.generatedLine) {
        addMappingWithCode(lastMapping, shiftNextLine());
        lastGeneratedLine++;
        lastGeneratedColumn = 0;
      } else {
        var nextLine = remainingLines[0];
        var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
        remainingLines[0] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
        lastGeneratedColumn = mapping.generatedColumn;
        addMappingWithCode(lastMapping, code);
        lastMapping = mapping;
        return;
      }
    }
    while (lastGeneratedLine < mapping.generatedLine) {
      node.add(shiftNextLine());
      lastGeneratedLine++;
    }
    if (lastGeneratedColumn < mapping.generatedColumn) {
      var nextLine = remainingLines[0];
      node.add(nextLine.substr(0, mapping.generatedColumn));
      remainingLines[0] = nextLine.substr(mapping.generatedColumn);
      lastGeneratedColumn = mapping.generatedColumn;
    }
    lastMapping = mapping;
  }, this);
  if (remainingLines.length > 0) {
    if (lastMapping) {
      addMappingWithCode(lastMapping, shiftNextLine());
    }
    node.add(remainingLines.join(""));
  }
  aSourceMapConsumer.sources.forEach(function (sourceFile) {
    var content = aSourceMapConsumer.sourceContentFor(sourceFile);
    if (content != null) {
      if (aRelativePath != null) {
        sourceFile = util.join(aRelativePath, sourceFile);
      }
      node.setSourceContent(sourceFile, content);
    }
  });
  return node;
  function addMappingWithCode(mapping, code) {
    if (mapping === null || mapping.source === undefined) {
      node.add(code);
    } else {
      var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
      node.add(new SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
    }
  }
};
SourceNode.prototype.add = function SourceNode_add(aChunk) {
  if (Array.isArray(aChunk)) {
    aChunk.forEach(function (chunk) {
      this.add(chunk);
    }, this);
  } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    if (aChunk) {
      this.children.push(aChunk);
    }
  } else {
    throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
  }
  return this;
};
SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
  if (Array.isArray(aChunk)) {
    for (var i = aChunk.length - 1; i >= 0; i--) {
      this.prepend(aChunk[i]);
    }
  } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    this.children.unshift(aChunk);
  } else {
    throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
  }
  return this;
};
SourceNode.prototype.walk = function SourceNode_walk(aFn) {
  var chunk;
  for (var i = 0, len = this.children.length; i < len; i++) {
    chunk = this.children[i];
    if (chunk[isSourceNode]) {
      chunk.walk(aFn);
    } else {
      if (chunk !== '') {
        aFn(chunk, {
          source: this.source,
          line: this.line,
          column: this.column,
          name: this.name
        });
      }
    }
  }
};
SourceNode.prototype.join = function SourceNode_join(aSep) {
  var newChildren;
  var i;
  var len = this.children.length;
  if (len > 0) {
    newChildren = [];
    for (i = 0; i < len - 1; i++) {
      newChildren.push(this.children[i]);
      newChildren.push(aSep);
    }
    newChildren.push(this.children[i]);
    this.children = newChildren;
  }
  return this;
};
SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
  var lastChild = this.children[this.children.length - 1];
  if (lastChild[isSourceNode]) {
    lastChild.replaceRight(aPattern, aReplacement);
  } else if (typeof lastChild === 'string') {
    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
  } else {
    this.children.push(''.replace(aPattern, aReplacement));
  }
  return this;
};
SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
  this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
};
SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
  for (var i = 0, len = this.children.length; i < len; i++) {
    if (this.children[i][isSourceNode]) {
      this.children[i].walkSourceContents(aFn);
    }
  }
  var sources = Object.keys(this.sourceContents);
  for (var i = 0, len = sources.length; i < len; i++) {
    aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
  }
};
SourceNode.prototype.toString = function SourceNode_toString() {
  var str = "";
  this.walk(function (chunk) {
    str += chunk;
  });
  return str;
};
SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
  var generated = {
    code: "",
    line: 1,
    column: 0
  };
  var map = new SourceMapGenerator(aArgs);
  var sourceMappingActive = false;
  var lastOriginalSource = null;
  var lastOriginalLine = null;
  var lastOriginalColumn = null;
  var lastOriginalName = null;
  this.walk(function (chunk, original) {
    generated.code += chunk;
    if (original.source !== null && original.line !== null && original.column !== null) {
      if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) {
        map.addMapping({
          source: original.source,
          original: {
            line: original.line,
            column: original.column
          },
          generated: {
            line: generated.line,
            column: generated.column
          },
          name: original.name
        });
      }
      lastOriginalSource = original.source;
      lastOriginalLine = original.line;
      lastOriginalColumn = original.column;
      lastOriginalName = original.name;
      sourceMappingActive = true;
    } else if (sourceMappingActive) {
      map.addMapping({
        generated: {
          line: generated.line,
          column: generated.column
        }
      });
      lastOriginalSource = null;
      sourceMappingActive = false;
    }
    for (var idx = 0, length = chunk.length; idx < length; idx++) {
      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
        generated.line++;
        generated.column = 0;
        if (idx + 1 === length) {
          lastOriginalSource = null;
          sourceMappingActive = false;
        } else if (sourceMappingActive) {
          map.addMapping({
            source: original.source,
            original: {
              line: original.line,
              column: original.column
            },
            generated: {
              line: generated.line,
              column: generated.column
            },
            name: original.name
          });
        }
      } else {
        generated.column++;
      }
    }
  });
  this.walkSourceContents(function (sourceFile, sourceContent) {
    map.setSourceContent(sourceFile, sourceContent);
  });
  return {
    code: generated.code,
    map: map
  };
};
exports.SourceNode = SourceNode;

/***/ }),

/***/ 817:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var base64 = __webpack_require__(353);
var VLQ_BASE_SHIFT = 5;
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
var VLQ_BASE_MASK = VLQ_BASE - 1;
var VLQ_CONTINUATION_BIT = VLQ_BASE;
function toVLQSigned(aValue) {
  return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative ? -shifted : shifted;
}
exports.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;
  var vlq = toVLQSigned(aValue);
  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += base64.encode(digit);
  } while (vlq > 0);
  return encoded;
};
exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;
  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }
    digit = base64.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }
    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);
  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};

/***/ }),

/***/ 876:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var base64VLQ = __webpack_require__(817);
var util = __webpack_require__(254);
var ArraySet = (__webpack_require__(139).ArraySet);
var MappingList = (__webpack_require__(377).MappingList);
function SourceMapGenerator(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = util.getArg(aArgs, 'file', null);
  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
  this._sources = new ArraySet();
  this._names = new ArraySet();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}
SourceMapGenerator.prototype._version = 3;
SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
  var sourceRoot = aSourceMapConsumer.sourceRoot;
  var generator = new SourceMapGenerator({
    file: aSourceMapConsumer.file,
    sourceRoot: sourceRoot
  });
  aSourceMapConsumer.eachMapping(function (mapping) {
    var newMapping = {
      generated: {
        line: mapping.generatedLine,
        column: mapping.generatedColumn
      }
    };
    if (mapping.source != null) {
      newMapping.source = mapping.source;
      if (sourceRoot != null) {
        newMapping.source = util.relative(sourceRoot, newMapping.source);
      }
      newMapping.original = {
        line: mapping.originalLine,
        column: mapping.originalColumn
      };
      if (mapping.name != null) {
        newMapping.name = mapping.name;
      }
    }
    generator.addMapping(newMapping);
  });
  aSourceMapConsumer.sources.forEach(function (sourceFile) {
    var content = aSourceMapConsumer.sourceContentFor(sourceFile);
    if (content != null) {
      generator.setSourceContent(sourceFile, content);
    }
  });
  return generator;
};
SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
  var generated = util.getArg(aArgs, 'generated');
  var original = util.getArg(aArgs, 'original', null);
  var source = util.getArg(aArgs, 'source', null);
  var name = util.getArg(aArgs, 'name', null);
  if (!this._skipValidation) {
    this._validateMapping(generated, original, source, name);
  }
  if (source != null) {
    source = String(source);
    if (!this._sources.has(source)) {
      this._sources.add(source);
    }
  }
  if (name != null) {
    name = String(name);
    if (!this._names.has(name)) {
      this._names.add(name);
    }
  }
  this._mappings.add({
    generatedLine: generated.line,
    generatedColumn: generated.column,
    originalLine: original != null && original.line,
    originalColumn: original != null && original.column,
    source: source,
    name: name
  });
};
SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
  var source = aSourceFile;
  if (this._sourceRoot != null) {
    source = util.relative(this._sourceRoot, source);
  }
  if (aSourceContent != null) {
    if (!this._sourcesContents) {
      this._sourcesContents = Object.create(null);
    }
    this._sourcesContents[util.toSetString(source)] = aSourceContent;
  } else if (this._sourcesContents) {
    delete this._sourcesContents[util.toSetString(source)];
    if (Object.keys(this._sourcesContents).length === 0) {
      this._sourcesContents = null;
    }
  }
};
SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
  var sourceFile = aSourceFile;
  if (aSourceFile == null) {
    if (aSourceMapConsumer.file == null) {
      throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' + 'or the source map\'s "file" property. Both were omitted.');
    }
    sourceFile = aSourceMapConsumer.file;
  }
  var sourceRoot = this._sourceRoot;
  if (sourceRoot != null) {
    sourceFile = util.relative(sourceRoot, sourceFile);
  }
  var newSources = new ArraySet();
  var newNames = new ArraySet();
  this._mappings.unsortedForEach(function (mapping) {
    if (mapping.source === sourceFile && mapping.originalLine != null) {
      var original = aSourceMapConsumer.originalPositionFor({
        line: mapping.originalLine,
        column: mapping.originalColumn
      });
      if (original.source != null) {
        mapping.source = original.source;
        if (aSourceMapPath != null) {
          mapping.source = util.join(aSourceMapPath, mapping.source);
        }
        if (sourceRoot != null) {
          mapping.source = util.relative(sourceRoot, mapping.source);
        }
        mapping.originalLine = original.line;
        mapping.originalColumn = original.column;
        if (original.name != null) {
          mapping.name = original.name;
        }
      }
    }
    var source = mapping.source;
    if (source != null && !newSources.has(source)) {
      newSources.add(source);
    }
    var name = mapping.name;
    if (name != null && !newNames.has(name)) {
      newNames.add(name);
    }
  }, this);
  this._sources = newSources;
  this._names = newNames;
  aSourceMapConsumer.sources.forEach(function (sourceFile) {
    var content = aSourceMapConsumer.sourceContentFor(sourceFile);
    if (content != null) {
      if (aSourceMapPath != null) {
        sourceFile = util.join(aSourceMapPath, sourceFile);
      }
      if (sourceRoot != null) {
        sourceFile = util.relative(sourceRoot, sourceFile);
      }
      this.setSourceContent(sourceFile, content);
    }
  }, this);
};
SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
  if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) {
    return;
  } else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aOriginal && 'line' in aOriginal && 'column' in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) {
    return;
  } else {
    throw new Error('Invalid mapping: ' + JSON.stringify({
      generated: aGenerated,
      source: aSource,
      original: aOriginal,
      name: aName
    }));
  }
};
SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
  var previousGeneratedColumn = 0;
  var previousGeneratedLine = 1;
  var previousOriginalColumn = 0;
  var previousOriginalLine = 0;
  var previousName = 0;
  var previousSource = 0;
  var result = '';
  var next;
  var mapping;
  var nameIdx;
  var sourceIdx;
  var mappings = this._mappings.toArray();
  for (var i = 0, len = mappings.length; i < len; i++) {
    mapping = mappings[i];
    next = '';
    if (mapping.generatedLine !== previousGeneratedLine) {
      previousGeneratedColumn = 0;
      while (mapping.generatedLine !== previousGeneratedLine) {
        next += ';';
        previousGeneratedLine++;
      }
    } else {
      if (i > 0) {
        if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
          continue;
        }
        next += ',';
      }
    }
    next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
    previousGeneratedColumn = mapping.generatedColumn;
    if (mapping.source != null) {
      sourceIdx = this._sources.indexOf(mapping.source);
      next += base64VLQ.encode(sourceIdx - previousSource);
      previousSource = sourceIdx;
      next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
      previousOriginalLine = mapping.originalLine - 1;
      next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
      previousOriginalColumn = mapping.originalColumn;
      if (mapping.name != null) {
        nameIdx = this._names.indexOf(mapping.name);
        next += base64VLQ.encode(nameIdx - previousName);
        previousName = nameIdx;
      }
    }
    result += next;
  }
  return result;
};
SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
  return aSources.map(function (source) {
    if (!this._sourcesContents) {
      return null;
    }
    if (aSourceRoot != null) {
      source = util.relative(aSourceRoot, source);
    }
    var key = util.toSetString(source);
    return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
  }, this);
};
SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
  var map = {
    version: this._version,
    sources: this._sources.toArray(),
    names: this._names.toArray(),
    mappings: this._serializeMappings()
  };
  if (this._file != null) {
    map.file = this._file;
  }
  if (this._sourceRoot != null) {
    map.sourceRoot = this._sourceRoot;
  }
  if (this._sourcesContents) {
    map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
  }
  return map;
};
SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
  return JSON.stringify(this.toJSON());
};
exports.SourceMapGenerator = SourceMapGenerator;

/***/ }),

/***/ 884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ForceSendLog: () => (/* binding */ ForceSendLog),
  LogError: () => (/* binding */ LogError),
  LogInfo: () => (/* binding */ LogInfo),
  initializeLogging: () => (/* binding */ initializeLogging),
  newErrorContext: () => (/* binding */ newErrorContext),
  replaceUndefinedWithNull: () => (/* binding */ replaceUndefinedWithNull),
  silentForceSendLog: () => (/* binding */ silentForceSendLog)
});

// EXTERNAL MODULE: ../runtime/build/buildService.ts + 1 modules
var buildService = __webpack_require__(774);
;// ../runtime/logging/log.types.ts
var LogKind = (LogKind2 => {
  LogKind2["Info"] = "Info";
  LogKind2["Error"] = "Error";
  LogKind2["Analytics"] = "Analytics";
  LogKind2["Performance"] = "Performance";
  LogKind2["Interface"] = "Interface";
  LogKind2["Availability"] = "Availability";
  LogKind2["Reliability"] = "Reliability";
  LogKind2["Framework"] = "Framework";
  LogKind2["Flight"] = "Flight";
  return LogKind2;
})(LogKind || {});
var LogCategory = (LogCategory2 => {
  LogCategory2["ClientInfo"] = "ClientInfo";
  LogCategory2["ClientError"] = "ClientError";
  LogCategory2["ClientAnalytics"] = "ClientAnalytics";
  LogCategory2["ClientPerformance"] = "ClientPerformance";
  LogCategory2["ClientAvailability"] = "ClientAvailability";
  LogCategory2["ClientReliability"] = "ClientReliability";
  LogCategory2["ClientFramework"] = "ClientFramework";
  return LogCategory2;
})(LogCategory || {});
var PerfMarkerPrefix = (PerfMarkerPrefix2 => {
  PerfMarkerPrefix2["Microsoft365AdminCenter"] = "@ms/mac";
  return PerfMarkerPrefix2;
})(PerfMarkerPrefix || {});
function isInfo(option) {
  return option.type === "Info" || option.type === "Interface";
}
function isError(option) {
  return option.type === "Error";
}
function isAnalytics(option) {
  return option.type === "Analytics";
}
function isPerformance(option) {
  return option.type === "Performance";
}
function isAvailability(option) {
  return option.type === "Availability";
}
function isReliability(option) {
  return option.type === "Reliability";
}
function isFramework(option) {
  return option.type === "Framework";
}
function isFlight(option) {
  return option.type === "Flight";
}
;// ../runtime/logging/broadcastLogger.ts

const registeredLoggers = new Map();
function addLogger(name, loggerObj) {
  if (registeredLoggers.has(name)) {
    throw new Error(`Logger ${name} already exists`);
  }
  registeredLoggers.set(name, loggerObj);
}
function removeLogger(name) {
  registeredLoggers.delete(name);
}
function broadcastLogger(options) {
  broadCastTo(options, registeredLoggers);
}
function addAdditionalLoggers(additionalLoggers) {
  if (additionalLoggers) {
    Object.keys(additionalLoggers).forEach(key => {
      addLogger(key, {
        logger: additionalLoggers[key]
      });
    });
  }
}
function flush() {
  const flushArray = [];
  registeredLoggers.forEach(loggerObj => {
    if (loggerObj.flush) {
      flushArray.push(loggerObj.flush());
    }
  });
  return Promise.all(flushArray);
}
function broadCastTo(options, loggers) {
  loggers.forEach((loggerObj, name) => {
    try {
      loggerObj.logger(options);
    } catch (error) {
      const restLoggers = new Map(loggers);
      restLoggers.delete(name);
      broadCastTo({
        id: "500294",
        type: LogKind.Error,
        logCategory: LogCategory.ClientError,
        message: `Failure in logger: ${name}`,
        error: error instanceof Error ? error : new Error(String(error))
      }, restLoggers);
    }
  });
}
const log = broadcastLogger;
;// ../runtime/logging/consoleLogger.ts


let enabled = false;
const storageKey = "centro.runtime.consoleLogger";
try {
  enabled = localStorage.getItem(storageKey) === "1";
} catch (e) {
  log({
    id: "514091",
    type: LogKind.Error,
    message: "Failed to retrive console logger state with local storage",
    error: e instanceof Error ? e : new Error(String(e)),
    logCategory: LogCategory.ClientError
  });
}
function consoleLoggerState(toggle = false) {
  if (toggle) {
    if (enabled) {
      enabled = false;
    } else {
      enabled = true;
    }
    try {
      if (enabled) {
        localStorage.setItem(storageKey, "1");
      } else {
        localStorage.removeItem(storageKey);
      }
    } catch (e) {
      log({
        id: "514092",
        type: LogKind.Error,
        message: "Failed to persist console logger state with local storage",
        error: e instanceof Error ? e : new Error(String(e)),
        logCategory: LogCategory.ClientError
      });
    }
  }
  return enabled;
}
function consoleLogger(options) {
  if (!enabled) {
    return;
  }
  let data;
  if (typeof options.data === "object") {
    data = JSON.stringify(options.data, void 0, 2);
  } else if (typeof options.data === "string") {
    data = options.data;
  } else {
    data = "";
  }
  if (isFlight(options)) {
    console.log(`${options.type}: ${options.flightName}`);
    console.log(`${JSON.stringify(options.flightData, void 0, 2)}`);
  } else if (!isPerformance(options) && !isAnalytics(options)) {
    const message = options.message || "";
    console.log(`${options.type}: ${options.id} - ${message}
${data}`);
  } else if (isAnalytics(options)) {
    console.log(`${options.type}: HINT: ${options.id}
VALUE: ${data}`);
  } else {
    console.log(`${options.type}: ${options.id}
${data}`);
  }
  if (isError(options)) {
    console.log(options.error);
  }
}
function overtakeWindowConsole() {
  const wrap = f => {
    return (...args) => {
      if (enabled) {
        return f.apply(window.console, args);
      }
      return;
    };
  };
  window.console.log = wrap(window.console.log);
  window.console.warn = wrap(window.console.warn);
  window.console.debug = wrap(window.console.debug);
  window.console.error = wrap(window.console.error);
  window.console.info = wrap(window.console.info);
  window.console.trace = wrap(window.console.trace);
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/v4.js + 5 modules
var v4 = __webpack_require__(561);
;// ../runtime/logging/loggingUtils.ts


function handlerWithAnalytics(onInvoke, hint, payload, payloadCallback) {
  return function wrappedHandler(...args) {
    if (payloadCallback !== void 0) {
      payload = payloadCallback.call(this, payload, ...args);
    }
    log({
      id: hint,
      type: LogKind.Analytics,
      data: JSON.stringify(payload)
    });
    if (typeof onInvoke === "function") {
      return onInvoke.call(this, ...args);
    }
    return;
  };
}
function logAnalytics(id, data = "") {
  log({
    id,
    type: LogKind.Analytics,
    data
  });
}
function scrubMessage(message) {
  let scrubbedMessage = message;
  try {
    if (typeof message === "string") {
      scrubbedMessage = scrubbedMessage.replaceAll(/[a-zA-Z0-9_\-'.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+/g, "<upn>").replaceAll(/[a-zA-Z0-9_\-'.]+%40[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+/g, "<upn>");
      scrubbedMessage = scrubbedMessage.replaceAll(/eyJ0eX[A-Za-z0-9-_]+\.+[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=/]+/g, "<token>").replaceAll(/eyJhbG[A-Za-z0-9-_]+\.+[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=/]+/g, "<token>");
    }
  } catch (e) {}
  return scrubbedMessage;
}
function logError(id, error, message, data) {
  log({
    id,
    data,
    type: LogKind.Error,
    error,
    message: message || error.message
  });
}
let ariaLoggerId;
function setAriaLoggerId(ariaLogId) {
  ariaLoggerId = ariaLogId;
}
function getAriaLoggerId() {
  return ariaLoggerId;
}
function getErrorMessage(error) {
  return JSON.stringify(error);
}
;// ../runtime/configuration/runtimeDataSources.ts
var SupportedHostingApps = (SupportedHostingApps2 => {
  SupportedHostingApps2["M365AdminPortal"] = "M365AdminPortal";
  SupportedHostingApps2["SPOAdminPortal"] = "SPOAdminPortal";
  SupportedHostingApps2["SPOPortal"] = "SPOPortal";
  SupportedHostingApps2["EXOAdminPortal"] = "EXOAdminPortal";
  SupportedHostingApps2["TeamsAdminPortal"] = "TeamsAdminPortal";
  SupportedHostingApps2["SecurityPortal"] = "SecurityPortal";
  SupportedHostingApps2["CompliancePortal"] = "CompliancePortal";
  SupportedHostingApps2["M365SCCPortal"] = "M365SCCPortal";
  SupportedHostingApps2["SupportCentral"] = "SupportCentral";
  SupportedHostingApps2["IbizaMTMPortal"] = "IbizaMTMPortal";
  SupportedHostingApps2["CloudCostManagementPortal"] = "CloudCostManagementPortal";
  SupportedHostingApps2["Rave"] = "Rave";
  SupportedHostingApps2["DynamicsPortal"] = "DynamicsPortal";
  SupportedHostingApps2["TeamsApp"] = "TeamsApp";
  SupportedHostingApps2["M365DefenderSMB"] = "M365DefenderSMB";
  SupportedHostingApps2["Windows365Portal"] = "Windows365Portal";
  SupportedHostingApps2["PPACAdminPortal"] = "PPACAdminPortal";
  SupportedHostingApps2["VivaGoals"] = "VivaGoals";
  SupportedHostingApps2["VivaPulse"] = "VivaPulse";
  SupportedHostingApps2["VivaInsights"] = "VivaInsights";
  SupportedHostingApps2["FireSurveysHost"] = "FireSurveysHost";
  SupportedHostingApps2["AEM"] = "AEM";
  SupportedHostingApps2["ExcelPythonAddon"] = "ExcelPythonAddon";
  SupportedHostingApps2["AdminAppMetaOSTeams"] = "AdminAppMetaOSTeams";
  SupportedHostingApps2["AdminAppMetaOSOffice"] = "AdminAppMetaOSOffice";
  SupportedHostingApps2["AdminAppMetaOSOutlook"] = "AdminAppMetaOSOutlook";
  SupportedHostingApps2["Project"] = "Project";
  SupportedHostingApps2["Planner"] = "Planner";
  SupportedHostingApps2["Visio"] = "Visio";
  SupportedHostingApps2["Clipchamp"] = "Clipchamp";
  return SupportedHostingApps2;
})(SupportedHostingApps || {});
var RuntimeDataSources = (RuntimeDataSources2 => {
  RuntimeDataSources2["Static"] = "centro.runtime.static";
  RuntimeDataSources2["Error"] = "centro.hvc.error";
  RuntimeDataSources2["LogMetadata"] = "centro.hvc.log-metadata";
  RuntimeDataSources2["CentroHvcLoader"] = "centro.hvc.loader-data";
  return RuntimeDataSources2;
})(RuntimeDataSources || {});
;// ../runtime/routing/history.ts

let history_history = void 0;
const parseUrls = urlJsonString => {
  const urlMap = new Map();
  if (urlJsonString) {
    const urls = JSON.parse(urlJsonString);
    Object.entries(urls).forEach(([key, value]) => {
      try {
        urlMap.set(SupportedHostingApps[key], new URL(value));
      } catch (e) {}
    });
  }
  return urlMap;
};
function setHistory(newHistory) {
  history_history = newHistory;
}
function getHistory() {
  if (history_history === void 0) {
    throw new Error("History object has not been set");
  }
  return history_history;
}
;// ./logging/CentroLogger.ts


var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};


var LogLevel = (LogLevel2 => {
  LogLevel2[LogLevel2["Trace"] = 0] = "Trace";
  LogLevel2[LogLevel2["Info"] = 1] = "Info";
  LogLevel2[LogLevel2["Comment"] = 2] = "Comment";
  LogLevel2[LogLevel2["Warning"] = 3] = "Warning";
  LogLevel2[LogLevel2["Error"] = 4] = "Error";
  LogLevel2[LogLevel2["Critical"] = 5] = "Critical";
  return LogLevel2;
})(LogLevel || {});
function makeCentroKustoLogger(appIdStr, kustoEndpointStr, hostNameStr, versionInfoStr) {
  const loggingQueueInterval = 1e3;
  const queue = [];
  const xhrPromise = Promise.resolve();
  let remoteLoggerSequenceNumber = 0;
  const appId = appIdStr;
  const kustoEndpoint = kustoEndpointStr;
  const hostName = hostNameStr;
  const versionInfo = versionInfoStr;
  let isNextSendLogScheduled = false;
  const scheduleNextSend = () => {
    if (queue.length === 0) {
      isNextSendLogScheduled = false;
      return;
    }
    isNextSendLogScheduled = true;
    setTimeout(() => {
      sendInstrumentRequest().catch(() => {});
    }, loggingQueueInterval);
  };
  const sendInstrumentRequest = () => __async(this, null, function* () {
    if (queue.length === 0) {
      scheduleNextSend();
      return;
    }
    try {
      const response = yield fetch(kustoEndpoint, {
        method: "POST",
        keepalive: true,
        body: JSON.stringify(queue),
        headers: {
          "Content-Type": "application/json",
          "x-ms-mac-hostingapp": hostName,
          "x-ms-mac-appid": appId,
          "x-ms-mac-version": versionInfo
        }
      });
      if (response.status !== 204) {
        const err = new Error(`Request to /api/instrument/logclient failed, server responseCode: ${response.status} body: ${yield response.text()}`);
        console.log(err);
        throw err;
      }
    } catch (e) {}
    queue.length = 0;
    scheduleNextSend();
  });
  scheduleNextSend();
  const queueLog = data => {
    queue.push(data);
    if (!isNextSendLogScheduled) {
      scheduleNextSend();
    }
  };
  function flush() {
    return __async(this, null, function* () {
      yield Promise.all([xhrPromise, sendInstrumentRequest()]);
    });
  }
  function macKustoLogger(options) {
    remoteLoggerSequenceNumber += 1;
    let pathName = "",
      flyoutName = "";
    try {
      pathName = getHistory().location.pathname;
      if (pathName !== null && pathName.indexOf(":") !== -1) {
        const pathArray = pathName.split(":");
        pathName = pathArray[0];
        flyoutName = pathArray[1];
      }
    } catch (error) {
      pathName = "";
      flyoutName = "";
    }
    const tagId = parseInt(options.id, 10);
    queueLog({
      TagId: tagId,
      LogLevel: 1,
      LogCategory: options.logCategory || LogCategory.ClientInfo,
      Message: scrubMessage(options.message || ""),
      Adhoc0: appId,
      Adhoc1: remoteLoggerSequenceNumber.toString(),
      Adhoc2: scrubMessage(JSON.stringify({
        data: options.data
      })),
      Adhoc5: scrubMessage(flyoutName),
      PageName: scrubMessage(pathName)
    });
    if (isError(options)) {
      const stack = options.error.stack || "";
      queueLog({
        TagId: 500781,
        LogLevel: 4,
        LogCategory: options.logCategory || LogCategory.ClientError,
        Message: scrubMessage(`UI Exception: ${options.error.message || ""}`),
        Adhoc0: appId,
        Adhoc1: remoteLoggerSequenceNumber.toString(),
        Adhoc2: scrubMessage(JSON.stringify({
          version: versionInfo,
          stack
        })),
        Adhoc3: tagId.toString(),
        Adhoc5: scrubMessage(flyoutName),
        PageName: scrubMessage(pathName)
      });
    }
  }
  return {
    logger: macKustoLogger,
    flush
  };
}
;// ./logging/logging.ts


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var logging_async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};






let loggersInitialized = false;
function initializeLogging(params) {
  var _a;
  if (loggersInitialized) {
    return;
  }
  const appId = (_a = params.appId) != null ? _a : (0,v4["default"])();
  window.__inappfeedback_centro_appid = appId;
  const {
    centroEnvironmentBaseUrl: baseUrl,
    hostName
  } = params;
  const centroBaseUrl = baseUrl.substring(baseUrl.length - 1) === "/" ? baseUrl.substring(0, baseUrl.length - 1) : baseUrl;
  const kustoEndpoint = `${centroBaseUrl}/api/instrument/logclient`;
  addLogger("consoleLogger", {
    logger: consoleLogger
  });
  addLogger("minimalKustoLogger", makeCentroKustoLogger(appId, kustoEndpoint, hostName, buildService.moduleAndVersionInfo));
  loggersInitialized = true;
}
const newErrorContext = () => {
  return {
    httpStatusCode: null,
    httpStatusText: null,
    httpResponseText: null
  };
};
const isPrimitiveArray = value => {
  if (value.length === 0) {
    return true;
  }
  if (typeof value[0] === "string" || typeof value[0] === "number" || typeof value[0] === "boolean") {
    return true;
  }
  return false;
};
const replaceUndefinedWithNull = data => {
  const result = {};
  for (const key in data) {
    if (!Object.prototype.hasOwnProperty.call(data, key)) {
      continue;
    }
    const nextData = data[key];
    if (nextData === void 0 || nextData === null) {
      result[key] = null;
    } else if (typeof nextData === "string" || typeof nextData === "number" || typeof nextData === "boolean") {
      result[key] = nextData;
    } else if (Array.isArray(nextData)) {
      if (isPrimitiveArray(nextData)) {
        result[key] = nextData;
      } else {
        result[key] = nextData.map(value => replaceUndefinedWithNull(value));
      }
    } else {
      result[key] = replaceUndefinedWithNull(nextData);
    }
  }
  return result;
};
const logMessagePrefix = "InAppFeedback HVC: ";
const LogError = (id, message, err, data) => {
  let error;
  if (typeof err === "string") {
    error = new Error(err);
  } else if (!(err instanceof Error)) {
    error = new Error(`Unknown Error: ${JSON.stringify(err)}`);
  } else {
    error = err;
  }
  log({
    id,
    type: LogKind.Error,
    message: logMessagePrefix + message,
    error,
    data: __spreadProps(__spreadValues({}, data), {
      timestamp: Date.now()
    })
  });
};
const LogInfo = (id, message, data) => {
  log({
    id,
    type: LogKind.Info,
    message: logMessagePrefix + message,
    data: __spreadProps(__spreadValues({}, data), {
      timestamp: Date.now()
    })
  });
};
const ForceSendLog = flush;
const silentForceSendLog = () => logging_async(void 0, null, function* () {
  try {
    yield flush();
  } catch (e) {
    console.log("Failed to flush logs");
  }
});

/***/ }),

/***/ 891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ForceSendLog: () => (/* reexport safe */ _logging__WEBPACK_IMPORTED_MODULE_0__.ForceSendLog),
/* harmony export */   LogError: () => (/* reexport safe */ _logging__WEBPACK_IMPORTED_MODULE_0__.LogError),
/* harmony export */   LogInfo: () => (/* reexport safe */ _logging__WEBPACK_IMPORTED_MODULE_0__.LogInfo),
/* harmony export */   initializeLogging: () => (/* reexport safe */ _logging__WEBPACK_IMPORTED_MODULE_0__.initializeLogging),
/* harmony export */   newErrorContext: () => (/* reexport safe */ _logging__WEBPACK_IMPORTED_MODULE_0__.newErrorContext),
/* harmony export */   replaceUndefinedWithNull: () => (/* reexport safe */ _logging__WEBPACK_IMPORTED_MODULE_0__.replaceUndefinedWithNull),
/* harmony export */   silentForceSendLog: () => (/* reexport safe */ _logging__WEBPACK_IMPORTED_MODULE_0__.silentForceSendLog)
/* harmony export */ });
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(884);




/***/ }),

/***/ 941:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var util = __webpack_require__(254);
var binarySearch = __webpack_require__(460);
var ArraySet = (__webpack_require__(139).ArraySet);
var base64VLQ = __webpack_require__(817);
var quickSort = (__webpack_require__(324).quickSort);
function SourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }
  return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap) : new BasicSourceMapConsumer(sourceMap);
}
SourceMapConsumer.fromSourceMap = function (aSourceMap) {
  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
};
SourceMapConsumer.prototype._version = 3;
SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
  get: function () {
    if (!this.__generatedMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }
    return this.__generatedMappings;
  }
});
SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
  get: function () {
    if (!this.__originalMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }
    return this.__originalMappings;
  }
});
SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
  var c = aStr.charAt(index);
  return c === ";" || c === ",";
};
SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
  throw new Error("Subclasses must implement _parseMappings");
};
SourceMapConsumer.GENERATED_ORDER = 1;
SourceMapConsumer.ORIGINAL_ORDER = 2;
SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer.LEAST_UPPER_BOUND = 2;
SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
  var context = aContext || null;
  var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
  var mappings;
  switch (order) {
    case SourceMapConsumer.GENERATED_ORDER:
      mappings = this._generatedMappings;
      break;
    case SourceMapConsumer.ORIGINAL_ORDER:
      mappings = this._originalMappings;
      break;
    default:
      throw new Error("Unknown order of iteration.");
  }
  var sourceRoot = this.sourceRoot;
  mappings.map(function (mapping) {
    var source = mapping.source === null ? null : this._sources.at(mapping.source);
    if (source != null && sourceRoot != null) {
      source = util.join(sourceRoot, source);
    }
    return {
      source: source,
      generatedLine: mapping.generatedLine,
      generatedColumn: mapping.generatedColumn,
      originalLine: mapping.originalLine,
      originalColumn: mapping.originalColumn,
      name: mapping.name === null ? null : this._names.at(mapping.name)
    };
  }, this).forEach(aCallback, context);
};
SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
  var line = util.getArg(aArgs, 'line');
  var needle = {
    source: util.getArg(aArgs, 'source'),
    originalLine: line,
    originalColumn: util.getArg(aArgs, 'column', 0)
  };
  if (this.sourceRoot != null) {
    needle.source = util.relative(this.sourceRoot, needle.source);
  }
  if (!this._sources.has(needle.source)) {
    return [];
  }
  needle.source = this._sources.indexOf(needle.source);
  var mappings = [];
  var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, binarySearch.LEAST_UPPER_BOUND);
  if (index >= 0) {
    var mapping = this._originalMappings[index];
    if (aArgs.column === undefined) {
      var originalLine = mapping.originalLine;
      while (mapping && mapping.originalLine === originalLine) {
        mappings.push({
          line: util.getArg(mapping, 'generatedLine', null),
          column: util.getArg(mapping, 'generatedColumn', null),
          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
        });
        mapping = this._originalMappings[++index];
      }
    } else {
      var originalColumn = mapping.originalColumn;
      while (mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn) {
        mappings.push({
          line: util.getArg(mapping, 'generatedLine', null),
          column: util.getArg(mapping, 'generatedColumn', null),
          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
        });
        mapping = this._originalMappings[++index];
      }
    }
  }
  return mappings;
};
exports.SourceMapConsumer = SourceMapConsumer;
function BasicSourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }
  var version = util.getArg(sourceMap, 'version');
  var sources = util.getArg(sourceMap, 'sources');
  var names = util.getArg(sourceMap, 'names', []);
  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
  var mappings = util.getArg(sourceMap, 'mappings');
  var file = util.getArg(sourceMap, 'file', null);
  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }
  sources = sources.map(String).map(util.normalize).map(function (source) {
    return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
  });
  this._names = ArraySet.fromArray(names.map(String), true);
  this._sources = ArraySet.fromArray(sources, true);
  this.sourceRoot = sourceRoot;
  this.sourcesContent = sourcesContent;
  this._mappings = mappings;
  this.file = file;
}
BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
  var smc = Object.create(BasicSourceMapConsumer.prototype);
  var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
  var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
  smc.sourceRoot = aSourceMap._sourceRoot;
  smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
  smc.file = aSourceMap._file;
  var generatedMappings = aSourceMap._mappings.toArray().slice();
  var destGeneratedMappings = smc.__generatedMappings = [];
  var destOriginalMappings = smc.__originalMappings = [];
  for (var i = 0, length = generatedMappings.length; i < length; i++) {
    var srcMapping = generatedMappings[i];
    var destMapping = new Mapping();
    destMapping.generatedLine = srcMapping.generatedLine;
    destMapping.generatedColumn = srcMapping.generatedColumn;
    if (srcMapping.source) {
      destMapping.source = sources.indexOf(srcMapping.source);
      destMapping.originalLine = srcMapping.originalLine;
      destMapping.originalColumn = srcMapping.originalColumn;
      if (srcMapping.name) {
        destMapping.name = names.indexOf(srcMapping.name);
      }
      destOriginalMappings.push(destMapping);
    }
    destGeneratedMappings.push(destMapping);
  }
  quickSort(smc.__originalMappings, util.compareByOriginalPositions);
  return smc;
};
BasicSourceMapConsumer.prototype._version = 3;
Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
  get: function () {
    return this._sources.toArray().map(function (s) {
      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
    }, this);
  }
});
function Mapping() {
  this.generatedLine = 0;
  this.generatedColumn = 0;
  this.source = null;
  this.originalLine = null;
  this.originalColumn = null;
  this.name = null;
}
BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
  var generatedLine = 1;
  var previousGeneratedColumn = 0;
  var previousOriginalLine = 0;
  var previousOriginalColumn = 0;
  var previousSource = 0;
  var previousName = 0;
  var length = aStr.length;
  var index = 0;
  var cachedSegments = {};
  var temp = {};
  var originalMappings = [];
  var generatedMappings = [];
  var mapping, str, segment, end, value;
  while (index < length) {
    if (aStr.charAt(index) === ';') {
      generatedLine++;
      index++;
      previousGeneratedColumn = 0;
    } else if (aStr.charAt(index) === ',') {
      index++;
    } else {
      mapping = new Mapping();
      mapping.generatedLine = generatedLine;
      for (end = index; end < length; end++) {
        if (this._charIsMappingSeparator(aStr, end)) {
          break;
        }
      }
      str = aStr.slice(index, end);
      segment = cachedSegments[str];
      if (segment) {
        index += str.length;
      } else {
        segment = [];
        while (index < end) {
          base64VLQ.decode(aStr, index, temp);
          value = temp.value;
          index = temp.rest;
          segment.push(value);
        }
        if (segment.length === 2) {
          throw new Error('Found a source, but no line and column');
        }
        if (segment.length === 3) {
          throw new Error('Found a source and line, but no column');
        }
        cachedSegments[str] = segment;
      }
      mapping.generatedColumn = previousGeneratedColumn + segment[0];
      previousGeneratedColumn = mapping.generatedColumn;
      if (segment.length > 1) {
        mapping.source = previousSource + segment[1];
        previousSource += segment[1];
        mapping.originalLine = previousOriginalLine + segment[2];
        previousOriginalLine = mapping.originalLine;
        mapping.originalLine += 1;
        mapping.originalColumn = previousOriginalColumn + segment[3];
        previousOriginalColumn = mapping.originalColumn;
        if (segment.length > 4) {
          mapping.name = previousName + segment[4];
          previousName += segment[4];
        }
      }
      generatedMappings.push(mapping);
      if (typeof mapping.originalLine === 'number') {
        originalMappings.push(mapping);
      }
    }
  }
  quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
  this.__generatedMappings = generatedMappings;
  quickSort(originalMappings, util.compareByOriginalPositions);
  this.__originalMappings = originalMappings;
};
BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
  if (aNeedle[aLineName] <= 0) {
    throw new TypeError('Line must be greater than or equal to 1, got ' + aNeedle[aLineName]);
  }
  if (aNeedle[aColumnName] < 0) {
    throw new TypeError('Column must be greater than or equal to 0, got ' + aNeedle[aColumnName]);
  }
  return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
};
BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
  for (var index = 0; index < this._generatedMappings.length; ++index) {
    var mapping = this._generatedMappings[index];
    if (index + 1 < this._generatedMappings.length) {
      var nextMapping = this._generatedMappings[index + 1];
      if (mapping.generatedLine === nextMapping.generatedLine) {
        mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
        continue;
      }
    }
    mapping.lastGeneratedColumn = Infinity;
  }
};
BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
  var needle = {
    generatedLine: util.getArg(aArgs, 'line'),
    generatedColumn: util.getArg(aArgs, 'column')
  };
  var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", util.compareByGeneratedPositionsDeflated, util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND));
  if (index >= 0) {
    var mapping = this._generatedMappings[index];
    if (mapping.generatedLine === needle.generatedLine) {
      var source = util.getArg(mapping, 'source', null);
      if (source !== null) {
        source = this._sources.at(source);
        if (this.sourceRoot != null) {
          source = util.join(this.sourceRoot, source);
        }
      }
      var name = util.getArg(mapping, 'name', null);
      if (name !== null) {
        name = this._names.at(name);
      }
      return {
        source: source,
        line: util.getArg(mapping, 'originalLine', null),
        column: util.getArg(mapping, 'originalColumn', null),
        name: name
      };
    }
  }
  return {
    source: null,
    line: null,
    column: null,
    name: null
  };
};
BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
  if (!this.sourcesContent) {
    return false;
  }
  return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function (sc) {
    return sc == null;
  });
};
BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
  if (!this.sourcesContent) {
    return null;
  }
  if (this.sourceRoot != null) {
    aSource = util.relative(this.sourceRoot, aSource);
  }
  if (this._sources.has(aSource)) {
    return this.sourcesContent[this._sources.indexOf(aSource)];
  }
  var url;
  if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
    var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
    if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) {
      return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
    }
    if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) {
      return this.sourcesContent[this._sources.indexOf("/" + aSource)];
    }
  }
  if (nullOnMissing) {
    return null;
  } else {
    throw new Error('"' + aSource + '" is not in the SourceMap.');
  }
};
BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
  var source = util.getArg(aArgs, 'source');
  if (this.sourceRoot != null) {
    source = util.relative(this.sourceRoot, source);
  }
  if (!this._sources.has(source)) {
    return {
      line: null,
      column: null,
      lastColumn: null
    };
  }
  source = this._sources.indexOf(source);
  var needle = {
    source: source,
    originalLine: util.getArg(aArgs, 'line'),
    originalColumn: util.getArg(aArgs, 'column')
  };
  var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND));
  if (index >= 0) {
    var mapping = this._originalMappings[index];
    if (mapping.source === needle.source) {
      return {
        line: util.getArg(mapping, 'generatedLine', null),
        column: util.getArg(mapping, 'generatedColumn', null),
        lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
      };
    }
  }
  return {
    line: null,
    column: null,
    lastColumn: null
  };
};
exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
function IndexedSourceMapConsumer(aSourceMap) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
  }
  var version = util.getArg(sourceMap, 'version');
  var sections = util.getArg(sourceMap, 'sections');
  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }
  this._sources = new ArraySet();
  this._names = new ArraySet();
  var lastOffset = {
    line: -1,
    column: 0
  };
  this._sections = sections.map(function (s) {
    if (s.url) {
      throw new Error('Support for url field in sections not implemented.');
    }
    var offset = util.getArg(s, 'offset');
    var offsetLine = util.getArg(offset, 'line');
    var offsetColumn = util.getArg(offset, 'column');
    if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) {
      throw new Error('Section offsets must be ordered and non-overlapping.');
    }
    lastOffset = offset;
    return {
      generatedOffset: {
        generatedLine: offsetLine + 1,
        generatedColumn: offsetColumn + 1
      },
      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
    };
  });
}
IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
IndexedSourceMapConsumer.prototype._version = 3;
Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
  get: function () {
    var sources = [];
    for (var i = 0; i < this._sections.length; i++) {
      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
        sources.push(this._sections[i].consumer.sources[j]);
      }
    }
    return sources;
  }
});
IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
  var needle = {
    generatedLine: util.getArg(aArgs, 'line'),
    generatedColumn: util.getArg(aArgs, 'column')
  };
  var sectionIndex = binarySearch.search(needle, this._sections, function (needle, section) {
    var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
    if (cmp) {
      return cmp;
    }
    return needle.generatedColumn - section.generatedOffset.generatedColumn;
  });
  var section = this._sections[sectionIndex];
  if (!section) {
    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }
  return section.consumer.originalPositionFor({
    line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
    column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
    bias: aArgs.bias
  });
};
IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
  return this._sections.every(function (s) {
    return s.consumer.hasContentsOfAllSources();
  });
};
IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
  for (var i = 0; i < this._sections.length; i++) {
    var section = this._sections[i];
    var content = section.consumer.sourceContentFor(aSource, true);
    if (content) {
      return content;
    }
  }
  if (nullOnMissing) {
    return null;
  } else {
    throw new Error('"' + aSource + '" is not in the SourceMap.');
  }
};
IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
  for (var i = 0; i < this._sections.length; i++) {
    var section = this._sections[i];
    if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
      continue;
    }
    var generatedPosition = section.consumer.generatedPositionFor(aArgs);
    if (generatedPosition) {
      var ret = {
        line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
        column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
      };
      return ret;
    }
  }
  return {
    line: null,
    column: null
  };
};
IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
  this.__generatedMappings = [];
  this.__originalMappings = [];
  for (var i = 0; i < this._sections.length; i++) {
    var section = this._sections[i];
    var sectionMappings = section.consumer._generatedMappings;
    for (var j = 0; j < sectionMappings.length; j++) {
      var mapping = sectionMappings[j];
      var source = section.consumer._sources.at(mapping.source);
      if (section.consumer.sourceRoot !== null) {
        source = util.join(section.consumer.sourceRoot, source);
      }
      this._sources.add(source);
      source = this._sources.indexOf(source);
      var name = section.consumer._names.at(mapping.name);
      this._names.add(name);
      name = this._names.indexOf(name);
      var adjustedMapping = {
        source: source,
        generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
        generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        originalLine: mapping.originalLine,
        originalColumn: mapping.originalColumn,
        name: name
      };
      this.__generatedMappings.push(adjustedMapping);
      if (typeof adjustedMapping.originalLine === 'number') {
        this.__originalMappings.push(adjustedMapping);
      }
    }
  }
  quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
  quickSort(this.__originalMappings, util.compareByOriginalPositions);
};
exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CentroUrlDod: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.CentroUrlDod),
/* harmony export */   CentroUrlGcc: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.CentroUrlGcc),
/* harmony export */   CentroUrlGccm: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.CentroUrlGccm),
/* harmony export */   CentroUrlInt: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.CentroUrlInt),
/* harmony export */   CentroUrlProd: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.CentroUrlProd),
/* harmony export */   CentroUrlTenantCloudTypeMap: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.CentroUrlTenantCloudTypeMap),
/* harmony export */   DefaultMajorVersion: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.DefaultMajorVersion),
/* harmony export */   ForceSendLog: () => (/* reexport safe */ _logging_index__WEBPACK_IMPORTED_MODULE_3__.ForceSendLog),
/* harmony export */   KustoEndpoint: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.KustoEndpoint),
/* harmony export */   LogError: () => (/* reexport safe */ _logging_index__WEBPACK_IMPORTED_MODULE_3__.LogError),
/* harmony export */   LogInfo: () => (/* reexport safe */ _logging_index__WEBPACK_IMPORTED_MODULE_3__.LogInfo),
/* harmony export */   PerfPrefix: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.PerfPrefix),
/* harmony export */   ScreenCapturer: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.ScreenCapturer),
/* harmony export */   canDisplayFeedback: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.canDisplayFeedback),
/* harmony export */   canDisplayFeedbackNonCPS: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.canDisplayFeedbackNonCPS),
/* harmony export */   canSendEmailToOcv: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.canSendEmailToOcv),
/* harmony export */   getCentroUrl: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getCentroUrl),
/* harmony export */   getCloudPolicyServiceTokenAudience: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getCloudPolicyServiceTokenAudience),
/* harmony export */   getConfigFromInitOptions: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getConfigFromInitOptions),
/* harmony export */   getConfigs: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getConfigs),
/* harmony export */   getEmailConsentType: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getEmailConsentType),
/* harmony export */   getOcvEmailConsentType: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getOcvEmailConsentType),
/* harmony export */   getPolicyFeatureSettings: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getPolicyFeatureSettings),
/* harmony export */   getTenantCloudType: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.getTenantCloudType),
/* harmony export */   guidRegexPattern: () => (/* reexport safe */ _constants_index__WEBPACK_IMPORTED_MODULE_2__.guidRegexPattern),
/* harmony export */   initializeLogging: () => (/* reexport safe */ _logging_index__WEBPACK_IMPORTED_MODULE_3__.initializeLogging),
/* harmony export */   isAIScenario: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isAIScenario),
/* harmony export */   isAIThumbsScenarioType: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isAIThumbsScenarioType),
/* harmony export */   isDisabledByCloudPolicy: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isDisabledByCloudPolicy),
/* harmony export */   isExplicitConsentForEmailProvided: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isExplicitConsentForEmailProvided),
/* harmony export */   isFeedbackDisabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isFeedbackDisabled),
/* harmony export */   isFeedbackLiteEnabledByPolicies: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isFeedbackLiteEnabledByPolicies),
/* harmony export */   isFileUploadEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isFileUploadEnabled),
/* harmony export */   isHostManagedContextDataEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isHostManagedContextDataEnabled),
/* harmony export */   isHostManagedContextDataEnabledForAiParams: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isHostManagedContextDataEnabledForAiParams),
/* harmony export */   isLocalBuild: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isLocalBuild),
/* harmony export */   isOptionalConnectedExperiencesEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isOptionalConnectedExperiencesEnabled),
/* harmony export */   isPolicyMissing: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isPolicyMissing),
/* harmony export */   isPublicFeedbackEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isPublicFeedbackEnabled),
/* harmony export */   isReproductionModeEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isReproductionModeEnabled),
/* harmony export */   isScenarioEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isScenarioEnabled),
/* harmony export */   isScreenRecordingEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isScreenRecordingEnabled),
/* harmony export */   isScreenshotEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isScreenshotEnabled),
/* harmony export */   isSelectEmailCollectionDefault: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isSelectEmailCollectionDefault),
/* harmony export */   isSelectHostManagedContextDataDefault: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isSelectHostManagedContextDataDefault),
/* harmony export */   isSelectScreenshotDefault: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isSelectScreenshotDefault),
/* harmony export */   isSelectShareContextDataDefault: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isSelectShareContextDataDefault),
/* harmony export */   isShareContextDataEnabled: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isShareContextDataEnabled),
/* harmony export */   isThumbsFeedbackType: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.isThumbsFeedbackType),
/* harmony export */   mergeObjects: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.mergeObjects),
/* harmony export */   newErrorContext: () => (/* reexport safe */ _logging_index__WEBPACK_IMPORTED_MODULE_3__.newErrorContext),
/* harmony export */   noop: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.noop),
/* harmony export */   promiseWithTimeout: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.promiseWithTimeout),
/* harmony export */   replaceUndefinedWithNull: () => (/* reexport safe */ _logging_index__WEBPACK_IMPORTED_MODULE_3__.replaceUndefinedWithNull),
/* harmony export */   sendEventSignal: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.sendEventSignal),
/* harmony export */   silentForceSendLog: () => (/* reexport safe */ _logging_index__WEBPACK_IMPORTED_MODULE_3__.silentForceSendLog),
/* harmony export */   unicodeSafeSubstring: () => (/* reexport safe */ _functions_index__WEBPACK_IMPORTED_MODULE_1__.unicodeSafeSubstring)
/* harmony export */ });
/* harmony import */ var _types_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(651);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _types_index__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _types_index__WEBPACK_IMPORTED_MODULE_0__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _functions_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(525);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(119);
/* harmony import */ var _logging_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891);






/******/ 	return __webpack_exports__;
/******/ })()
;
});